/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminCustomReferralListBase } from '../models';
// @ts-ignore
import type { AdminCustomReferralListResponse } from '../models';
// @ts-ignore
import type { AdminUserUpdateBody } from '../models';
// @ts-ignore
import type { AdminUserUpdateResponse } from '../models';
// @ts-ignore
import type { AnalyticsResponseSub } from '../models';
// @ts-ignore
import type { AppleAuthMobileBody } from '../models';
// @ts-ignore
import type { AppleAuthMobileResponse } from '../models';
// @ts-ignore
import type { BulkCompanyDeleteResponse } from '../models';
// @ts-ignore
import type { BulkResumeShareBody } from '../models';
// @ts-ignore
import type { BulkResumeShareResponse } from '../models';
// @ts-ignore
import type { CertificateVisibilityBody } from '../models';
// @ts-ignore
import type { CertificateVisibilityResponse } from '../models';
// @ts-ignore
import type { ChangePasswordBody } from '../models';
// @ts-ignore
import type { CollegeAutocompleteResponse } from '../models';
// @ts-ignore
import type { CompanyAutocompleteResponse } from '../models';
// @ts-ignore
import type { CompetitionLeaderboardResponse } from '../models';
// @ts-ignore
import type { CreateAwardResponse } from '../models';
// @ts-ignore
import type { CreateCertificationResponse } from '../models';
// @ts-ignore
import type { CreateCollegeBody } from '../models';
// @ts-ignore
import type { CreateCollegeResponse } from '../models';
// @ts-ignore
import type { CreateCompanyBody } from '../models';
// @ts-ignore
import type { CreateCompanyResponse } from '../models';
// @ts-ignore
import type { CreateEducationResponse } from '../models';
// @ts-ignore
import type { CreateInterestResponse } from '../models';
// @ts-ignore
import type { CreateJobRoleBody } from '../models';
// @ts-ignore
import type { CreateJobRoleResponse } from '../models';
// @ts-ignore
import type { CreateLanguageResponse } from '../models';
// @ts-ignore
import type { CreatePositionOfResponsibilityResponse } from '../models';
// @ts-ignore
import type { CreatePotentialApplicantListBody } from '../models';
// @ts-ignore
import type { CreatePotentialApplicantListResponse } from '../models';
// @ts-ignore
import type { CreatePotentialApplicantsBody } from '../models';
// @ts-ignore
import type { CreatePotentialApplicantsResponse } from '../models';
// @ts-ignore
import type { CreatePotentialRecruiterBody } from '../models';
// @ts-ignore
import type { CreateProjectResponse } from '../models';
// @ts-ignore
import type { CreatePublicationResponse } from '../models';
// @ts-ignore
import type { CreateReferralMilestoneBody } from '../models';
// @ts-ignore
import type { CreateUserBody } from '../models';
// @ts-ignore
import type { CreateUserResponse } from '../models';
// @ts-ignore
import type { CreateVolunteerExperienceResponse } from '../models';
// @ts-ignore
import type { DailyScoreResponseSub } from '../models';
// @ts-ignore
import type { DashboardPersonaBody } from '../models';
// @ts-ignore
import type { DashboardPersonaResponse } from '../models';
// @ts-ignore
import type { DeleteUserBody } from '../models';
// @ts-ignore
import type { DeleteUserResponse } from '../models';
// @ts-ignore
import type { EarnCreditsOverviewResponse } from '../models';
// @ts-ignore
import type { EducationDetails } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { FollowResponse } from '../models';
// @ts-ignore
import type { GAuthMobileBody } from '../models';
// @ts-ignore
import type { GAuthMobileResponse } from '../models';
// @ts-ignore
import type { GemsActivityParam } from '../models';
// @ts-ignore
import type { GemsActivityResponse } from '../models';
// @ts-ignore
import type { GetAllReferralMilestonesResponse } from '../models';
// @ts-ignore
import type { GetApplicantStatusInfo } from '../models';
// @ts-ignore
import type { GetCollegesResponse } from '../models';
// @ts-ignore
import type { GetCompanyResponseList } from '../models';
// @ts-ignore
import type { GetFeaturedCompaniesResponse } from '../models';
// @ts-ignore
import type { GetJobReferralsResponse } from '../models';
// @ts-ignore
import type { GetJobRolesResponse } from '../models';
// @ts-ignore
import type { GetPotentialApplicantListsResponse } from '../models';
// @ts-ignore
import type { GetPotentialApplicantsBody } from '../models';
// @ts-ignore
import type { GetPotentialApplicantsResponse } from '../models';
// @ts-ignore
import type { GetPotentialRecruiterCsvParam } from '../models';
// @ts-ignore
import type { GetPotentialRecruiterResponse } from '../models';
// @ts-ignore
import type { GetReferralMultiplierResponse } from '../models';
// @ts-ignore
import type { GetResumeAccessResponse } from '../models';
// @ts-ignore
import type { GetUserCreatedQuestionResponse } from '../models';
// @ts-ignore
import type { GetUserDetailByEmailResponse } from '../models';
// @ts-ignore
import type { IDList } from '../models';
// @ts-ignore
import type { IDListNumber } from '../models';
// @ts-ignore
import type { ImportPotentialApplicantListMembersBody } from '../models';
// @ts-ignore
import type { ImportPotentialApplicantListMembersResponse } from '../models';
// @ts-ignore
import type { IsUserAvailableResponse } from '../models';
// @ts-ignore
import type { JobProfileAwardBase } from '../models';
// @ts-ignore
import type { JobProfileCertificationBase } from '../models';
// @ts-ignore
import type { JobProfileInterestBase } from '../models';
// @ts-ignore
import type { JobProfileLanguageBase } from '../models';
// @ts-ignore
import type { JobProfilePositionOfResponsibilityBase } from '../models';
// @ts-ignore
import type { JobProfileProject } from '../models';
// @ts-ignore
import type { JobProfilePublicationBase } from '../models';
// @ts-ignore
import type { JobProfileVolunteerExperienceBase } from '../models';
// @ts-ignore
import type { JobRoleAutocompleteResponse } from '../models';
// @ts-ignore
import type { JsonResumeGenerate } from '../models';
// @ts-ignore
import type { LoginStreakResponse } from '../models';
// @ts-ignore
import type { MonthlyScoreDataSub } from '../models';
// @ts-ignore
import type { MyBadgesResponse } from '../models';
// @ts-ignore
import type { OnboardingDoneBody } from '../models';
// @ts-ignore
import type { OnboardingDoneResponse } from '../models';
// @ts-ignore
import type { OnlineUsersResponse } from '../models';
// @ts-ignore
import type { PotentialApplicantFacetResponse } from '../models';
// @ts-ignore
import type { PotentialApplicantsCourseSpecializationsResponse } from '../models';
// @ts-ignore
import type { PotentialApplicantsJobRolesResponse } from '../models';
// @ts-ignore
import type { PotentialApplicantsWithAssociatedJobsAutocompleteResponse } from '../models';
// @ts-ignore
import type { PotentialRecruiterParameter } from '../models';
// @ts-ignore
import type { PotentialRecruitersJobPostedCategoriesResponse } from '../models';
// @ts-ignore
import type { ProfileCompletionResponse } from '../models';
// @ts-ignore
import type { ProfileMiniResponse } from '../models';
// @ts-ignore
import type { ProfilePictureResponse } from '../models';
// @ts-ignore
import type { PublicCommunityActivity } from '../models';
// @ts-ignore
import type { PublicProfileAnalyticsResponse } from '../models';
// @ts-ignore
import type { RecordPendingAppReferralBody } from '../models';
// @ts-ignore
import type { ReferByEmailBody } from '../models';
// @ts-ignore
import type { ReferByEmailResponse } from '../models';
// @ts-ignore
import type { ReferralActivityLogResponse } from '../models';
// @ts-ignore
import type { ReferralEmailPreviewResponse } from '../models';
// @ts-ignore
import type { ReferralSummaryResponse } from '../models';
// @ts-ignore
import type { ResetPasswordBody } from '../models';
// @ts-ignore
import type { ResetPasswordResponse } from '../models';
// @ts-ignore
import type { ResumeActivityResponse } from '../models';
// @ts-ignore
import type { ResumeResponse } from '../models';
// @ts-ignore
import type { ResumeShareBody } from '../models';
// @ts-ignore
import type { RewardBonusBody } from '../models';
// @ts-ignore
import type { SendEmailOtpBody } from '../models';
// @ts-ignore
import type { SendEmailOtpRepsonse } from '../models';
// @ts-ignore
import type { SendPhoneOtpBodyBase } from '../models';
// @ts-ignore
import type { SendPhoneOtpResponse } from '../models';
// @ts-ignore
import type { SendResetPasswordResponse } from '../models';
// @ts-ignore
import type { SetNewPasswordBody } from '../models';
// @ts-ignore
import type { SkipProfileItemBody } from '../models';
// @ts-ignore
import type { SocialLinksBody } from '../models';
// @ts-ignore
import type { SocialLinksResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UpdateApplicantUserResumeResponse } from '../models';
// @ts-ignore
import type { UpdateJobRoleBody } from '../models';
// @ts-ignore
import type { UpdateJobRoleResponse } from '../models';
// @ts-ignore
import type { UpdateReferralMilestoneBody } from '../models';
// @ts-ignore
import type { UpdateReferralMultiplierBody } from '../models';
// @ts-ignore
import type { UpdateUserBody } from '../models';
// @ts-ignore
import type { UpdateUserEmailBody } from '../models';
// @ts-ignore
import type { UploadMiscImageResponse } from '../models';
// @ts-ignore
import type { UserCertificatesResponse } from '../models';
// @ts-ignore
import type { UserCommunityUpdatesActivity } from '../models';
// @ts-ignore
import type { UserReferralsResponse } from '../models';
// @ts-ignore
import type { UserResponse } from '../models';
// @ts-ignore
import type { UserResume } from '../models';
// @ts-ignore
import type { UserResumeList } from '../models';
// @ts-ignore
import type { VerifyEmailOtpBody } from '../models';
// @ts-ignore
import type { VerifyEmailOtpResponse } from '../models';
// @ts-ignore
import type { VerifyPhoneOtpBody } from '../models';
// @ts-ignore
import type { VerifyPhoneOtpResponse } from '../models';
// @ts-ignore
import type { WorkExperience } from '../models';
// @ts-ignore
import type { WorkExperienceResponse } from '../models';
/**
 * UserApiApi - axios parameter creator
 */
export const UserApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiActivateFreeAbekusPremium: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/abekus-premium/free`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobProfileAwardBase} jobProfileAwardBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAddAward: async (jobProfileAwardBase: JobProfileAwardBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobProfileAwardBase' is not null or undefined
            assertParamExists('userApiAddAward', 'jobProfileAwardBase', jobProfileAwardBase)
            const localVarPath = `/user/award`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfileAwardBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobProfileCertificationBase} jobProfileCertificationBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAddCertification: async (jobProfileCertificationBase: JobProfileCertificationBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobProfileCertificationBase' is not null or undefined
            assertParamExists('userApiAddCertification', 'jobProfileCertificationBase', jobProfileCertificationBase)
            const localVarPath = `/user/certification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfileCertificationBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} followedUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAddFollowedUsers: async (followedUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'followedUserId' is not null or undefined
            assertParamExists('userApiAddFollowedUsers', 'followedUserId', followedUserId)
            const localVarPath = `/user/follow/{followed_user_id}`
                .replace('{followed_user_id}', encodeURIComponent(String(followedUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobProfileInterestBase} jobProfileInterestBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAddInterest: async (jobProfileInterestBase: JobProfileInterestBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobProfileInterestBase' is not null or undefined
            assertParamExists('userApiAddInterest', 'jobProfileInterestBase', jobProfileInterestBase)
            const localVarPath = `/user/interest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfileInterestBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobProfileLanguageBase} jobProfileLanguageBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAddLanguage: async (jobProfileLanguageBase: JobProfileLanguageBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobProfileLanguageBase' is not null or undefined
            assertParamExists('userApiAddLanguage', 'jobProfileLanguageBase', jobProfileLanguageBase)
            const localVarPath = `/user/language`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfileLanguageBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobProfilePositionOfResponsibilityBase} jobProfilePositionOfResponsibilityBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAddPositionOfResponsibility: async (jobProfilePositionOfResponsibilityBase: JobProfilePositionOfResponsibilityBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobProfilePositionOfResponsibilityBase' is not null or undefined
            assertParamExists('userApiAddPositionOfResponsibility', 'jobProfilePositionOfResponsibilityBase', jobProfilePositionOfResponsibilityBase)
            const localVarPath = `/user/position-of-responsibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfilePositionOfResponsibilityBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobProfilePublicationBase} jobProfilePublicationBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAddPublication: async (jobProfilePublicationBase: JobProfilePublicationBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobProfilePublicationBase' is not null or undefined
            assertParamExists('userApiAddPublication', 'jobProfilePublicationBase', jobProfilePublicationBase)
            const localVarPath = `/user/publication`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfilePublicationBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobProfileVolunteerExperienceBase} jobProfileVolunteerExperienceBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAddVolunteerExperience: async (jobProfileVolunteerExperienceBase: JobProfileVolunteerExperienceBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobProfileVolunteerExperienceBase' is not null or undefined
            assertParamExists('userApiAddVolunteerExperience', 'jobProfileVolunteerExperienceBase', jobProfileVolunteerExperienceBase)
            const localVarPath = `/user/volunteer-experience`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfileVolunteerExperienceBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {AdminUserUpdateBody} adminUserUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAdminUserUpdate: async (userId: string, adminUserUpdateBody: AdminUserUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userApiAdminUserUpdate', 'userId', userId)
            // verify required parameter 'adminUserUpdateBody' is not null or undefined
            assertParamExists('userApiAdminUserUpdate', 'adminUserUpdateBody', adminUserUpdateBody)
            const localVarPath = `/admin/user-update/{user_id}`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUserUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AppleAuthMobileBody} appleAuthMobileBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAppleAuthMobile: async (appleAuthMobileBody: AppleAuthMobileBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appleAuthMobileBody' is not null or undefined
            assertParamExists('userApiAppleAuthMobile', 'appleAuthMobileBody', appleAuthMobileBody)
            const localVarPath = `/apple-auth-mobile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appleAuthMobileBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAutofillProfileFromResume: async (resumeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeId' is not null or undefined
            assertParamExists('userApiAutofillProfileFromResume', 'resumeId', resumeId)
            const localVarPath = `/user/resume/{resume_id}/autofill`
                .replace('{resume_id}', encodeURIComponent(String(resumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IDListNumber} iDListNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiBulkPopulateUserResumes: async (iDListNumber: IDListNumber, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iDListNumber' is not null or undefined
            assertParamExists('userApiBulkPopulateUserResumes', 'iDListNumber', iDListNumber)
            const localVarPath = `/candidates/bulk-populate-resumes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iDListNumber, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} educationId 
         * @param {EducationDetails} educationDetails 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiChangeEducationDetails: async (educationId: string, educationDetails: EducationDetails, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'educationId' is not null or undefined
            assertParamExists('userApiChangeEducationDetails', 'educationId', educationId)
            // verify required parameter 'educationDetails' is not null or undefined
            assertParamExists('userApiChangeEducationDetails', 'educationDetails', educationDetails)
            const localVarPath = `/user/education_details/{education_id}`
                .replace('{education_id}', encodeURIComponent(String(educationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(educationDetails, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {JobProfileProject} jobProfileProject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiChangeProject: async (projectId: string, jobProfileProject: JobProfileProject, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('userApiChangeProject', 'projectId', projectId)
            // verify required parameter 'jobProfileProject' is not null or undefined
            assertParamExists('userApiChangeProject', 'jobProfileProject', jobProfileProject)
            const localVarPath = `/user/project/{project_id}`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfileProject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChangePasswordBody} changePasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiChangeUserPassword: async (changePasswordBody: ChangePasswordBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordBody' is not null or undefined
            assertParamExists('userApiChangeUserPassword', 'changePasswordBody', changePasswordBody)
            const localVarPath = `/user/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiChangeUserType: async (userType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userType' is not null or undefined
            assertParamExists('userApiChangeUserType', 'userType', userType)
            const localVarPath = `/user/user_type/{user_type}`
                .replace('{user_type}', encodeURIComponent(String(userType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} workId 
         * @param {WorkExperience} workExperience 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiChangeWorkDetails: async (workId: string, workExperience: WorkExperience, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workId' is not null or undefined
            assertParamExists('userApiChangeWorkDetails', 'workId', workId)
            // verify required parameter 'workExperience' is not null or undefined
            assertParamExists('userApiChangeWorkDetails', 'workExperience', workExperience)
            const localVarPath = `/user/work_details/{work_id}`
                .replace('{work_id}', encodeURIComponent(String(workId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workExperience, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiClearUserReferralMultiplier: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userApiClearUserReferralMultiplier', 'userId', userId)
            const localVarPath = `/admin/referral-multiplier/user/{user_id}`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCollegeAutocomplete: async (page?: number, pageSize?: number, query?: string, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/college-autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCollegeBody} createCollegeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCollegeDetails: async (createCollegeBody: CreateCollegeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCollegeBody' is not null or undefined
            assertParamExists('userApiCollegeDetails', 'createCollegeBody', createCollegeBody)
            const localVarPath = `/admin/college`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCollegeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCompanyAutocomplete: async (page?: string, pageSize?: string, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/company-autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCompanyCollegeDefaultColor: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/company_college_default_color`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCompanyBody} createCompanyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCompanyDetails: async (createCompanyBody: CreateCompanyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCompanyBody' is not null or undefined
            assertParamExists('userApiCompanyDetails', 'createCompanyBody', createCompanyBody)
            const localVarPath = `/admin/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePotentialRecruiterBody} createPotentialRecruiterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCreateBulkPotentialRecruiters: async (createPotentialRecruiterBody: CreatePotentialRecruiterBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPotentialRecruiterBody' is not null or undefined
            assertParamExists('userApiCreateBulkPotentialRecruiters', 'createPotentialRecruiterBody', createPotentialRecruiterBody)
            const localVarPath = `/potential-recruiters/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPotentialRecruiterBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateJobRoleBody} createJobRoleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCreateJobRole: async (createJobRoleBody: CreateJobRoleBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createJobRoleBody' is not null or undefined
            assertParamExists('userApiCreateJobRole', 'createJobRoleBody', createJobRoleBody)
            const localVarPath = `/admin/job-role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createJobRoleBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCreateMissingUsernames: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/create_missing_usernames`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePotentialApplicantListBody} createPotentialApplicantListBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCreatePotentialApplicantList: async (createPotentialApplicantListBody: CreatePotentialApplicantListBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPotentialApplicantListBody' is not null or undefined
            assertParamExists('userApiCreatePotentialApplicantList', 'createPotentialApplicantListBody', createPotentialApplicantListBody)
            const localVarPath = `/admin/potential-applicant-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPotentialApplicantListBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePotentialApplicantsBody} createPotentialApplicantsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCreatePotentialApplicants: async (createPotentialApplicantsBody: CreatePotentialApplicantsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPotentialApplicantsBody' is not null or undefined
            assertParamExists('userApiCreatePotentialApplicants', 'createPotentialApplicantsBody', createPotentialApplicantsBody)
            const localVarPath = `/admin/potential-applicant/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPotentialApplicantsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateReferralMilestoneBody} createReferralMilestoneBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCreateReferralMilestone: async (createReferralMilestoneBody: CreateReferralMilestoneBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createReferralMilestoneBody' is not null or undefined
            assertParamExists('userApiCreateReferralMilestone', 'createReferralMilestoneBody', createReferralMilestoneBody)
            const localVarPath = `/admin/referral-milestones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReferralMilestoneBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUserBody} createUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCreateUser: async (createUserBody: CreateUserBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserBody' is not null or undefined
            assertParamExists('userApiCreateUser', 'createUserBody', createUserBody)
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customReferralsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteAdminCustomReferralList: async (customReferralsId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customReferralsId' is not null or undefined
            assertParamExists('userApiDeleteAdminCustomReferralList', 'customReferralsId', customReferralsId)
            const localVarPath = `/admin/custom-user-referrals/{custom_referrals_id}`
                .replace('{custom_referrals_id}', encodeURIComponent(String(customReferralsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} awardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteAward: async (awardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'awardId' is not null or undefined
            assertParamExists('userApiDeleteAward', 'awardId', awardId)
            const localVarPath = `/user/award/{award_id}`
                .replace('{award_id}', encodeURIComponent(String(awardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} certId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteCertification: async (certId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certId' is not null or undefined
            assertParamExists('userApiDeleteCertification', 'certId', certId)
            const localVarPath = `/user/certification/{cert_id}`
                .replace('{cert_id}', encodeURIComponent(String(certId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IDList} iDList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteCollege: async (iDList: IDList, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iDList' is not null or undefined
            assertParamExists('userApiDeleteCollege', 'iDList', iDList)
            const localVarPath = `/admin/college/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iDList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IDList} iDList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteCompany: async (iDList: IDList, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iDList' is not null or undefined
            assertParamExists('userApiDeleteCompany', 'iDList', iDList)
            const localVarPath = `/admin/company/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iDList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} educationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteEducationDetails: async (educationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'educationId' is not null or undefined
            assertParamExists('userApiDeleteEducationDetails', 'educationId', educationId)
            const localVarPath = `/user/education_details/{education_id}`
                .replace('{education_id}', encodeURIComponent(String(educationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteInactiveUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/delete_inactive_users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteInterest: async (interestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interestId' is not null or undefined
            assertParamExists('userApiDeleteInterest', 'interestId', interestId)
            const localVarPath = `/user/interest/{interest_id}`
                .replace('{interest_id}', encodeURIComponent(String(interestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IDList} iDList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteJobRole: async (iDList: IDList, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iDList' is not null or undefined
            assertParamExists('userApiDeleteJobRole', 'iDList', iDList)
            const localVarPath = `/admin/job-role/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iDList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} languageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteLanguage: async (languageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'languageId' is not null or undefined
            assertParamExists('userApiDeleteLanguage', 'languageId', languageId)
            const localVarPath = `/user/language/{language_id}`
                .replace('{language_id}', encodeURIComponent(String(languageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteUserBody} deleteUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteMyUser: async (deleteUserBody: DeleteUserBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteUserBody' is not null or undefined
            assertParamExists('userApiDeleteMyUser', 'deleteUserBody', deleteUserBody)
            const localVarPath = `/delete-my-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteUserBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} positionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeletePositionOfResponsibility: async (positionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionId' is not null or undefined
            assertParamExists('userApiDeletePositionOfResponsibility', 'positionId', positionId)
            const localVarPath = `/user/position-of-responsibility/{position_id}`
                .replace('{position_id}', encodeURIComponent(String(positionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeletePotentialApplicantList: async (listId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listId' is not null or undefined
            assertParamExists('userApiDeletePotentialApplicantList', 'listId', listId)
            const localVarPath = `/admin/potential-applicant-lists/{list_id}`
                .replace('{list_id}', encodeURIComponent(String(listId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteProject: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('userApiDeleteProject', 'projectId', projectId)
            const localVarPath = `/user/project/{project_id}`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeletePublication: async (publicationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicationId' is not null or undefined
            assertParamExists('userApiDeletePublication', 'publicationId', publicationId)
            const localVarPath = `/user/publication/{publication_id}`
                .replace('{publication_id}', encodeURIComponent(String(publicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} milestoneId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteReferralMilestone: async (milestoneId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'milestoneId' is not null or undefined
            assertParamExists('userApiDeleteReferralMilestone', 'milestoneId', milestoneId)
            const localVarPath = `/admin/referral-milestones/{milestone_id}`
                .replace('{milestone_id}', encodeURIComponent(String(milestoneId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeAccessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteResumeAccess: async (resumeAccessId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeAccessId' is not null or undefined
            assertParamExists('userApiDeleteResumeAccess', 'resumeAccessId', resumeAccessId)
            const localVarPath = `/user/resume_access/{resume_access_id}`
                .replace('{resume_access_id}', encodeURIComponent(String(resumeAccessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} socialLinkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteSocialLink: async (socialLinkId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'socialLinkId' is not null or undefined
            assertParamExists('userApiDeleteSocialLink', 'socialLinkId', socialLinkId)
            const localVarPath = `/user/social_links/{social_link_id}`
                .replace('{social_link_id}', encodeURIComponent(String(socialLinkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteTempUserCompletely: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/delete-temp-user-completely`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteUserCompletely: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userApiDeleteUserCompletely', 'userId', userId)
            const localVarPath = `/delete-user-completely/{user_id}`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteUserResume: async (resumeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeId' is not null or undefined
            assertParamExists('userApiDeleteUserResume', 'resumeId', resumeId)
            const localVarPath = `/user/resume/{resume_id}`
                .replace('{resume_id}', encodeURIComponent(String(resumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} volunteerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteVolunteerExperience: async (volunteerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'volunteerId' is not null or undefined
            assertParamExists('userApiDeleteVolunteerExperience', 'volunteerId', volunteerId)
            const localVarPath = `/user/volunteer-experience/{volunteer_id}`
                .replace('{volunteer_id}', encodeURIComponent(String(volunteerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} workId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteWorkDetails: async (workId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workId' is not null or undefined
            assertParamExists('userApiDeleteWorkDetails', 'workId', workId)
            const localVarPath = `/user/work_details/{work_id}`
                .replace('{work_id}', encodeURIComponent(String(workId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EducationDetails} educationDetails 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiEducationDetails: async (educationDetails: EducationDetails, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'educationDetails' is not null or undefined
            assertParamExists('userApiEducationDetails', 'educationDetails', educationDetails)
            const localVarPath = `/user/education_details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(educationDetails, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendEmailOtpBody} sendEmailOtpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiEmailActivation: async (sendEmailOtpBody: SendEmailOtpBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendEmailOtpBody' is not null or undefined
            assertParamExists('userApiEmailActivation', 'sendEmailOtpBody', sendEmailOtpBody)
            const localVarPath = `/users/send-email-verify-otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendEmailOtpBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiFetchResumeJson: async (resumeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeId' is not null or undefined
            assertParamExists('userApiFetchResumeJson', 'resumeId', resumeId)
            const localVarPath = `/user/resume/{resume_id}`
                .replace('{resume_id}', encodeURIComponent(String(resumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiFetchUserResumesJson: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/resume`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GAuthMobileBody} gAuthMobileBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGauthMobile: async (gAuthMobileBody: GAuthMobileBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gAuthMobileBody' is not null or undefined
            assertParamExists('userApiGauthMobile', 'gAuthMobileBody', gAuthMobileBody)
            const localVarPath = `/gauth-mobile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gAuthMobileBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JsonResumeGenerate} jsonResumeGenerate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGenerateResume: async (jsonResumeGenerate: JsonResumeGenerate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jsonResumeGenerate' is not null or undefined
            assertParamExists('userApiGenerateResume', 'jsonResumeGenerate', jsonResumeGenerate)
            const localVarPath = `/user/resume`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jsonResumeGenerate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetAdminCustomReferralList: async (page?: number, pageSize?: number, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/custom-user-referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetAdminReferralMilestones: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/referral-milestones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetAdminReferralMultiplier: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/referral-multiplier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetApplicantStatusInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/applicant-status-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [collegeId] 
         * @param {string} [collegeName] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [status] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetCollege: async (collegeId?: string, collegeName?: string, page?: number, pageSize?: number, sortBy?: string, sortOrder?: string, status?: string, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/college`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (collegeId !== undefined) {
                localVarQueryParameter['college_id'] = collegeId;
            }

            if (collegeName !== undefined) {
                localVarQueryParameter['college_name'] = collegeName;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [companyId] 
         * @param {string} [companyName] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [status] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetCompany: async (companyId?: string, companyName?: string, page?: number, pageSize?: number, sortBy?: string, sortOrder?: string, status?: string, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (companyName !== undefined) {
                localVarQueryParameter['company_name'] = companyName;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetEarnCreditsGoals: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/earn-credits/goals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetFeaturedCompanies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/featured-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetFollowedUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/get_followed_users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GemsActivityParam} gemsActivityParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetGemsActivity: async (gemsActivityParam: GemsActivityParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gemsActivityParam' is not null or undefined
            assertParamExists('userApiGetGemsActivity', 'gemsActivityParam', gemsActivityParam)
            const localVarPath = `/admin/gems/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gemsActivityParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [jobRoleId] 
         * @param {string} [pageNo] 
         * @param {string} [pageSize] 
         * @param {boolean} [showJobAssociatedRoles] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [status] 
         * @param {string} [userSearchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetJobRole: async (jobRoleId?: string, pageNo?: string, pageSize?: string, showJobAssociatedRoles?: boolean, sortBy?: string, sortOrder?: string, status?: string, userSearchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/job-role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (jobRoleId !== undefined) {
                localVarQueryParameter['job_role_id'] = jobRoleId;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (showJobAssociatedRoles !== undefined) {
                localVarQueryParameter['show_job_associated_roles'] = showJobAssociatedRoles;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (userSearchQuery !== undefined) {
                localVarQueryParameter['user_search_query'] = userSearchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [competitionId] 
         * @param {boolean} [onlyFollowed] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {boolean | null} [showUserRank] 
         * @param {string | null} [skillId] 
         * @param {string} [timePeriod] 
         * @param {string | null} [userSearchQuery] 
         * @param {string | null} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetLeaderboardByUser: async (competitionId?: string | null, onlyFollowed?: boolean, page?: number, pageSize?: number, showUserRank?: boolean | null, skillId?: string | null, timePeriod?: string, userSearchQuery?: string | null, userType?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/leaderboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (competitionId !== undefined) {
                localVarQueryParameter['competition_id'] = competitionId;
            }

            if (onlyFollowed !== undefined) {
                localVarQueryParameter['only_followed'] = onlyFollowed;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (showUserRank !== undefined) {
                localVarQueryParameter['show_user_rank'] = showUserRank;
            }

            if (skillId !== undefined) {
                localVarQueryParameter['skill_id'] = skillId;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['time_period'] = timePeriod;
            }

            if (userSearchQuery !== undefined) {
                localVarQueryParameter['user_search_query'] = userSearchQuery;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetMiniProfile: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('userApiGetMiniProfile', 'username', username)
            const localVarPath = `/user/{username}/profile/mini`
                .replace('{username}', encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetMyBadges: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/badges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [excludeInvited] 
         * @param {boolean} [forInvite] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [roomId] 
         * @param {Array<string>} [skillIds] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetOnlineUsers: async (excludeInvited?: boolean, forInvite?: boolean, page?: number, pageSize?: number, roomId?: string | null, skillIds?: Array<string>, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/online-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (excludeInvited !== undefined) {
                localVarQueryParameter['exclude_invited'] = excludeInvited;
            }

            if (forInvite !== undefined) {
                localVarQueryParameter['for_invite'] = forInvite;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (roomId !== undefined) {
                localVarQueryParameter['room_id'] = roomId;
            }

            if (skillIds) {
                localVarQueryParameter['skill_ids'] = skillIds;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} field 
         * @param {boolean} [orderByMaxCount] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPotentialApplicantFacetValues: async (field: string, orderByMaxCount?: boolean, page?: number, pageSize?: number, searchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'field' is not null or undefined
            assertParamExists('userApiGetPotentialApplicantFacetValues', 'field', field)
            const localVarPath = `/admin/potential-applicant/facet/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (field !== undefined) {
                localVarQueryParameter['field'] = field;
            }

            if (orderByMaxCount !== undefined) {
                localVarQueryParameter['order_by_max_count'] = orderByMaxCount;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPotentialApplicantLists: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/potential-applicant-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPotentialApplicantsBody} getPotentialApplicantsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPotentialApplicants: async (getPotentialApplicantsBody: GetPotentialApplicantsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getPotentialApplicantsBody' is not null or undefined
            assertParamExists('userApiGetPotentialApplicants', 'getPotentialApplicantsBody', getPotentialApplicantsBody)
            const localVarPath = `/admin/potential-applicant/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPotentialApplicantsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [orderByMaxCount] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPotentialApplicantsCourseSpecializations: async (orderByMaxCount?: boolean, page?: number, pageSize?: number, searchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/potential-applicant/course-specialization/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderByMaxCount !== undefined) {
                localVarQueryParameter['order_by_max_count'] = orderByMaxCount;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [orderByMaxCount] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPotentialApplicantsJobRoles: async (orderByMaxCount?: boolean, page?: number, pageSize?: number, searchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/potential-applicant/job-role/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderByMaxCount !== undefined) {
                localVarQueryParameter['order_by_max_count'] = orderByMaxCount;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPotentialRecruiterCsvParam} getPotentialRecruiterCsvParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPotentialRecruiterGoogleAdsMetadataCsv: async (getPotentialRecruiterCsvParam: GetPotentialRecruiterCsvParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getPotentialRecruiterCsvParam' is not null or undefined
            assertParamExists('userApiGetPotentialRecruiterGoogleAdsMetadataCsv', 'getPotentialRecruiterCsvParam', getPotentialRecruiterCsvParam)
            const localVarPath = `/admin/potential-recruiter-google-ads-metadata/csv-download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPotentialRecruiterCsvParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PotentialRecruiterParameter} potentialRecruiterParameter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPotentialRecruiters: async (potentialRecruiterParameter: PotentialRecruiterParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'potentialRecruiterParameter' is not null or undefined
            assertParamExists('userApiGetPotentialRecruiters', 'potentialRecruiterParameter', potentialRecruiterParameter)
            const localVarPath = `/get-potential-recruiters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(potentialRecruiterParameter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [orderByMaxCount] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPotentialRecruitersJobPostedCategories: async (orderByMaxCount?: boolean, page?: number, pageSize?: number, searchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/potential-recruiters/job-posted-categories/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderByMaxCount !== undefined) {
                localVarQueryParameter['order_by_max_count'] = orderByMaxCount;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetProfileCompletion: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/profile-completion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPublicCommunityUpdatesActivity: async (page?: number, pageSize?: number, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/community-activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetQuestionAuthorList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/author-leaderboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} [endDate] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [startDate] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetReferralActivityLogs: async (userId: string, endDate?: string, page?: number, pageSize?: number, startDate?: string, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userApiGetReferralActivityLogs', 'userId', userId)
            const localVarPath = `/admin/referral_activity_logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [hideReferredBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetReferralEmailPreview: async (hideReferredBy?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/referral-email-preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (hideReferredBy !== undefined) {
                localVarQueryParameter['hide_referred_by'] = hideReferredBy;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [createdFrom] 
         * @param {string} [createdTo] 
         * @param {string} [lastReferredFrom] 
         * @param {string} [lastReferredTo] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetReferralSummary: async (createdFrom?: string, createdTo?: string, lastReferredFrom?: string, lastReferredTo?: string, page?: number, pageSize?: number, sortBy?: string, sortOrder?: string, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/referral_summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdFrom !== undefined) {
                localVarQueryParameter['created_from'] = createdFrom;
            }

            if (createdTo !== undefined) {
                localVarQueryParameter['created_to'] = createdTo;
            }

            if (lastReferredFrom !== undefined) {
                localVarQueryParameter['last_referred_from'] = lastReferredFrom;
            }

            if (lastReferredTo !== undefined) {
                localVarQueryParameter['last_referred_to'] = lastReferredTo;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetResumeAccessList: async (resumeId: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeId' is not null or undefined
            assertParamExists('userApiGetResumeAccessList', 'resumeId', resumeId)
            const localVarPath = `/user/resume/{resume_id}/access`
                .replace('{resume_id}', encodeURIComponent(String(resumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetResumeActivity: async (resumeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeId' is not null or undefined
            assertParamExists('userApiGetResumeActivity', 'resumeId', resumeId)
            const localVarPath = `/user/resume-activity/{resume_id}`
                .replace('{resume_id}', encodeURIComponent(String(resumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} endDate 
         * @param {string} startDate 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserActivityCalendar: async (endDate: string, startDate: string, username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('userApiGetUserActivityCalendar', 'endDate', endDate)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('userApiGetUserActivityCalendar', 'startDate', startDate)
            // verify required parameter 'username' is not null or undefined
            assertParamExists('userApiGetUserActivityCalendar', 'username', username)
            const localVarPath = `/user/{username}/activity-calendar`
                .replace('{username}', encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [domainId] 
         * @param {string} [onlyAttempted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserAnalytics: async (domainId?: string | null, onlyAttempted?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/analytics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (domainId !== undefined) {
                localVarQueryParameter['domain_id'] = domainId;
            }

            if (onlyAttempted !== undefined) {
                localVarQueryParameter['only_attempted'] = onlyAttempted;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserCertificates: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('userApiGetUserCertificates', 'username', username)
            const localVarPath = `/user/{username}/certificates`
                .replace('{username}', encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [skillId] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserCommunityUpdatesActivity: async (page?: number, pageSize?: number, skillId?: string | null, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/community-activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (skillId !== undefined) {
                localVarQueryParameter['skill_id'] = skillId;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [questionStatus] 
         * @param {string} [searchQuery] 
         * @param {Array<string>} [skillIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserCreatedQuestions: async (page?: number, pageSize?: number, questionStatus?: string, searchQuery?: string, skillIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/created_questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (questionStatus !== undefined) {
                localVarQueryParameter['question_status'] = questionStatus;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            if (skillIds) {
                localVarQueryParameter['skill_ids'] = skillIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserDetails: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('userApiGetUserDetails', 'email', email)
            const localVarPath = `/user/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserFullJson: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userApiGetUserFullJson', 'userId', userId)
            const localVarPath = `/user/{user_id}/full-json`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserLoginStreakDetails: async (endDate?: string, startDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/login-streak`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string | null} [endMonth] 
         * @param {number | null} [months] 
         * @param {string | null} [skillId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserMonthlyScore: async (username: string, endMonth?: string | null, months?: number | null, skillId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('userApiGetUserMonthlyScore', 'username', username)
            const localVarPath = `/user/{username}/profile_public/monthly_score`
                .replace('{username}', encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (endMonth !== undefined) {
                localVarQueryParameter['end_month'] = endMonth;
            }

            if (months !== undefined) {
                localVarQueryParameter['months'] = months;
            }

            if (skillId !== undefined) {
                localVarQueryParameter['skill_id'] = skillId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {boolean} [onlyAnalytics] 
         * @param {boolean} [onlyAttempted] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserPublicProfile: async (username: string, onlyAnalytics?: boolean, onlyAttempted?: boolean, pageNo?: number, pageSize?: number, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('userApiGetUserPublicProfile', 'username', username)
            const localVarPath = `/user/{username}/profile_public`
                .replace('{username}', encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (onlyAnalytics !== undefined) {
                localVarQueryParameter['only_analytics'] = onlyAnalytics;
            }

            if (onlyAttempted !== undefined) {
                localVarQueryParameter['only_attempted'] = onlyAttempted;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserReferrals: async (page?: number, pageSize?: number, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserResumes: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userApiGetUserResumes', 'userId', userId)
            const localVarPath = `/user/{user_id}/resumes`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserSelf: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/self`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserSelfResume: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/self/resume`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUsersJobReferralData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/get-job-referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} listId 
         * @param {ImportPotentialApplicantListMembersBody} importPotentialApplicantListMembersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiImportPotentialApplicantListMembers: async (listId: string, importPotentialApplicantListMembersBody: ImportPotentialApplicantListMembersBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listId' is not null or undefined
            assertParamExists('userApiImportPotentialApplicantListMembers', 'listId', listId)
            // verify required parameter 'importPotentialApplicantListMembersBody' is not null or undefined
            assertParamExists('userApiImportPotentialApplicantListMembers', 'importPotentialApplicantListMembersBody', importPotentialApplicantListMembersBody)
            const localVarPath = `/admin/potential-applicant-lists/{list_id}/members`
                .replace('{list_id}', encodeURIComponent(String(listId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importPotentialApplicantListMembersBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiIsUsernameAvailable: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('userApiIsUsernameAvailable', 'username', username)
            const localVarPath = `/user/username/{username}/is_available`
                .replace('{username}', encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [orderBy] 
         * @param {string} [pageNo] 
         * @param {string} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiJobRoleAutoComplete: async (orderBy?: string, pageNo?: string, pageSize?: string, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job-role/autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiLastAppliedPotentialApplicantJobRoles: async (searchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/last-applied-potential_applicants-job-roles/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiMarkAutoApplyDialogShown: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/auto-apply/dialog-seen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiMarkVoucherPopupDismissed: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/voucher-popup/dismissed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OnboardingDoneBody} onboardingDoneBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiOnboardingDone: async (onboardingDoneBody: OnboardingDoneBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingDoneBody' is not null or undefined
            assertParamExists('userApiOnboardingDone', 'onboardingDoneBody', onboardingDoneBody)
            const localVarPath = `/user/onboarding-done`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardingDoneBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendPhoneOtpBodyBase} sendPhoneOtpBodyBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiPhoneActivation: async (sendPhoneOtpBodyBase: SendPhoneOtpBodyBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendPhoneOtpBodyBase' is not null or undefined
            assertParamExists('userApiPhoneActivation', 'sendPhoneOtpBodyBase', sendPhoneOtpBodyBase)
            const localVarPath = `/users/send-phone-verify-otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendPhoneOtpBodyBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminCustomReferralListBase} adminCustomReferralListBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiPostAdminCustomReferralList: async (adminCustomReferralListBase: AdminCustomReferralListBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminCustomReferralListBase' is not null or undefined
            assertParamExists('userApiPostAdminCustomReferralList', 'adminCustomReferralListBase', adminCustomReferralListBase)
            const localVarPath = `/admin/custom-user-referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCustomReferralListBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobProfileProject} jobProfileProject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiProject: async (jobProfileProject: JobProfileProject, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobProfileProject' is not null or undefined
            assertParamExists('userApiProject', 'jobProfileProject', jobProfileProject)
            const localVarPath = `/user/project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfileProject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RecordPendingAppReferralBody} recordPendingAppReferralBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiRecordPendingAppReferral: async (recordPendingAppReferralBody: RecordPendingAppReferralBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordPendingAppReferralBody' is not null or undefined
            assertParamExists('userApiRecordPendingAppReferral', 'recordPendingAppReferralBody', recordPendingAppReferralBody)
            const localVarPath = `/pending-app-referral`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordPendingAppReferralBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiRecruiterDataNormalisation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/recruiter-data-normalisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReferByEmailBody} referByEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiReferByEmails: async (referByEmailBody: ReferByEmailBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referByEmailBody' is not null or undefined
            assertParamExists('userApiReferByEmails', 'referByEmailBody', referByEmailBody)
            const localVarPath = `/user/refer-by-emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(referByEmailBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} followedUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiRemoveFollowedUsers: async (followedUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'followedUserId' is not null or undefined
            assertParamExists('userApiRemoveFollowedUsers', 'followedUserId', followedUserId)
            const localVarPath = `/user/unfollow/{followed_user_id}`
                .replace('{followed_user_id}', encodeURIComponent(String(followedUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiResetUserCompletely: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userApiResetUserCompletely', 'userId', userId)
            const localVarPath = `/reset-user-completely/{user_id}`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiResetUserPassword: async (resetPasswordBody: ResetPasswordBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordBody' is not null or undefined
            assertParamExists('userApiResetUserPassword', 'resetPasswordBody', resetPasswordBody)
            const localVarPath = `/users/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiResumeDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/resume_details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkResumeShareBody} bulkResumeShareBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiResumeShare: async (bulkResumeShareBody: BulkResumeShareBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkResumeShareBody' is not null or undefined
            assertParamExists('userApiResumeShare', 'bulkResumeShareBody', bulkResumeShareBody)
            const localVarPath = `/user/resume-share`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkResumeShareBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiResumeView: async (resumeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeId' is not null or undefined
            assertParamExists('userApiResumeView', 'resumeId', resumeId)
            const localVarPath = `/user/resume/{resume_id}/view`
                .replace('{resume_id}', encodeURIComponent(String(resumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RewardBonusBody} rewardBonusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiRewardBonusToUser: async (rewardBonusBody: RewardBonusBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rewardBonusBody' is not null or undefined
            assertParamExists('userApiRewardBonusToUser', 'rewardBonusBody', rewardBonusBody)
            const localVarPath = `/admin/reward-bonus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rewardBonusBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiSelectDomain: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/select_domain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendEmailOtpBody} sendEmailOtpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiSendPasswordResetOtp: async (sendEmailOtpBody: SendEmailOtpBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendEmailOtpBody' is not null or undefined
            assertParamExists('userApiSendPasswordResetOtp', 'sendEmailOtpBody', sendEmailOtpBody)
            const localVarPath = `/users/send-password-reset-otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendEmailOtpBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} certificateId 
         * @param {CertificateVisibilityBody} certificateVisibilityBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiSetCertificateVisibility: async (certificateId: string, certificateVisibilityBody: CertificateVisibilityBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificateId' is not null or undefined
            assertParamExists('userApiSetCertificateVisibility', 'certificateId', certificateId)
            // verify required parameter 'certificateVisibilityBody' is not null or undefined
            assertParamExists('userApiSetCertificateVisibility', 'certificateVisibilityBody', certificateVisibilityBody)
            const localVarPath = `/user/certificates/{certificate_id}/visibility`
                .replace('{certificate_id}', encodeURIComponent(String(certificateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(certificateVisibilityBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardPersonaBody} dashboardPersonaBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiSetDashboardPersona: async (dashboardPersonaBody: DashboardPersonaBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardPersonaBody' is not null or undefined
            assertParamExists('userApiSetDashboardPersona', 'dashboardPersonaBody', dashboardPersonaBody)
            const localVarPath = `/user/dashboard-persona`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardPersonaBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetNewPasswordBody} setNewPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiSetNewPassword: async (setNewPasswordBody: SetNewPasswordBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setNewPasswordBody' is not null or undefined
            assertParamExists('userApiSetNewPassword', 'setNewPasswordBody', setNewPasswordBody)
            const localVarPath = `/user/set-new-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setNewPasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {UpdateReferralMultiplierBody} updateReferralMultiplierBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiSetUserReferralMultiplier: async (userId: string, updateReferralMultiplierBody: UpdateReferralMultiplierBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userApiSetUserReferralMultiplier', 'userId', userId)
            // verify required parameter 'updateReferralMultiplierBody' is not null or undefined
            assertParamExists('userApiSetUserReferralMultiplier', 'updateReferralMultiplierBody', updateReferralMultiplierBody)
            const localVarPath = `/admin/referral-multiplier/user/{user_id}`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReferralMultiplierBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SkipProfileItemBody} skipProfileItemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiSkipProfileCompletionItem: async (skipProfileItemBody: SkipProfileItemBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skipProfileItemBody' is not null or undefined
            assertParamExists('userApiSkipProfileCompletionItem', 'skipProfileItemBody', skipProfileItemBody)
            const localVarPath = `/user/profile-completion/skip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skipProfileItemBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiToggleResumeLike: async (resumeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeId' is not null or undefined
            assertParamExists('userApiToggleResumeLike', 'resumeId', resumeId)
            const localVarPath = `/user/resume/{resume_id}/like`
                .replace('{resume_id}', encodeURIComponent(String(resumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customReferralsId 
         * @param {AdminCustomReferralListBase} adminCustomReferralListBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateAdminCustomReferralList: async (customReferralsId: string, adminCustomReferralListBase: AdminCustomReferralListBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customReferralsId' is not null or undefined
            assertParamExists('userApiUpdateAdminCustomReferralList', 'customReferralsId', customReferralsId)
            // verify required parameter 'adminCustomReferralListBase' is not null or undefined
            assertParamExists('userApiUpdateAdminCustomReferralList', 'adminCustomReferralListBase', adminCustomReferralListBase)
            const localVarPath = `/admin/custom-user-referrals/{custom_referrals_id}`
                .replace('{custom_referrals_id}', encodeURIComponent(String(customReferralsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCustomReferralListBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateAutoPractiseMetadata: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/autoscript-practise-metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} awardId 
         * @param {JobProfileAwardBase} jobProfileAwardBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateAward: async (awardId: string, jobProfileAwardBase: JobProfileAwardBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'awardId' is not null or undefined
            assertParamExists('userApiUpdateAward', 'awardId', awardId)
            // verify required parameter 'jobProfileAwardBase' is not null or undefined
            assertParamExists('userApiUpdateAward', 'jobProfileAwardBase', jobProfileAwardBase)
            const localVarPath = `/user/award/{award_id}`
                .replace('{award_id}', encodeURIComponent(String(awardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfileAwardBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} certId 
         * @param {JobProfileCertificationBase} jobProfileCertificationBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateCertification: async (certId: string, jobProfileCertificationBase: JobProfileCertificationBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certId' is not null or undefined
            assertParamExists('userApiUpdateCertification', 'certId', certId)
            // verify required parameter 'jobProfileCertificationBase' is not null or undefined
            assertParamExists('userApiUpdateCertification', 'jobProfileCertificationBase', jobProfileCertificationBase)
            const localVarPath = `/user/certification/{cert_id}`
                .replace('{cert_id}', encodeURIComponent(String(certId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfileCertificationBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} collegeId 
         * @param {string | null} [address] 
         * @param {string} [approvalStatus] 
         * @param {string | null} [collegeAdminId] 
         * @param {string} [collegeName] 
         * @param {string | null} [collegeType] 
         * @param {string | null} [defaultColor] 
         * @param {string | null} [description] 
         * @param {string | null} [directorName] 
         * @param {string | null} [districtName] 
         * @param {string | null} [email] 
         * @param {string | null} [imageUrl] 
         * @param {boolean} [isEmailVerified] 
         * @param {boolean} [isPhoneVerified] 
         * @param {string | null} [jointDirectorName] 
         * @param {string | null} [password] 
         * @param {string | null} [phoneNumber] 
         * @param {string | null} [stateName] 
         * @param {string | null} [universityName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateCollege: async (collegeId: string, address?: string | null, approvalStatus?: string, collegeAdminId?: string | null, collegeName?: string, collegeType?: string | null, defaultColor?: string | null, description?: string | null, directorName?: string | null, districtName?: string | null, email?: string | null, imageUrl?: string | null, isEmailVerified?: boolean, isPhoneVerified?: boolean, jointDirectorName?: string | null, password?: string | null, phoneNumber?: string | null, stateName?: string | null, universityName?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'collegeId' is not null or undefined
            assertParamExists('userApiUpdateCollege', 'collegeId', collegeId)
            const localVarPath = `/admin/college/{college_id}`
                .replace('{college_id}', encodeURIComponent(String(collegeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }

            if (approvalStatus !== undefined) {
                localVarQueryParameter['approval_status'] = approvalStatus;
            }

            if (collegeAdminId !== undefined) {
                localVarQueryParameter['college_admin_id'] = collegeAdminId;
            }

            if (collegeName !== undefined) {
                localVarQueryParameter['college_name'] = collegeName;
            }

            if (collegeType !== undefined) {
                localVarQueryParameter['college_type'] = collegeType;
            }

            if (defaultColor !== undefined) {
                localVarQueryParameter['default_color'] = defaultColor;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (directorName !== undefined) {
                localVarQueryParameter['director_name'] = directorName;
            }

            if (districtName !== undefined) {
                localVarQueryParameter['district_name'] = districtName;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (imageUrl !== undefined) {
                localVarQueryParameter['image_url'] = imageUrl;
            }

            if (isEmailVerified !== undefined) {
                localVarQueryParameter['is_email_verified'] = isEmailVerified;
            }

            if (isPhoneVerified !== undefined) {
                localVarQueryParameter['is_phone_verified'] = isPhoneVerified;
            }

            if (jointDirectorName !== undefined) {
                localVarQueryParameter['joint_director_name'] = jointDirectorName;
            }

            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }

            if (stateName !== undefined) {
                localVarQueryParameter['state_name'] = stateName;
            }

            if (universityName !== undefined) {
                localVarQueryParameter['university_name'] = universityName;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string | null} [approvalStatus] 
         * @param {string | null} [companyDescription] 
         * @param {string | null} [companyName] 
         * @param {string | null} [companySize] 
         * @param {string | null} [corporateIdentificationNumber] 
         * @param {string | null} [defaultColor] 
         * @param {string | null} [imageUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateCompany: async (companyId: string, approvalStatus?: string | null, companyDescription?: string | null, companyName?: string | null, companySize?: string | null, corporateIdentificationNumber?: string | null, defaultColor?: string | null, imageUrl?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('userApiUpdateCompany', 'companyId', companyId)
            const localVarPath = `/admin/company/{company_id}`
                .replace('{company_id}', encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (approvalStatus !== undefined) {
                localVarQueryParameter['approval_status'] = approvalStatus;
            }

            if (companyDescription !== undefined) {
                localVarQueryParameter['company_description'] = companyDescription;
            }

            if (companyName !== undefined) {
                localVarQueryParameter['company_name'] = companyName;
            }

            if (companySize !== undefined) {
                localVarQueryParameter['company_size'] = companySize;
            }

            if (corporateIdentificationNumber !== undefined) {
                localVarQueryParameter['corporate_identification_number'] = corporateIdentificationNumber;
            }

            if (defaultColor !== undefined) {
                localVarQueryParameter['default_color'] = defaultColor;
            }

            if (imageUrl !== undefined) {
                localVarQueryParameter['image_url'] = imageUrl;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interestId 
         * @param {JobProfileInterestBase} jobProfileInterestBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateInterest: async (interestId: string, jobProfileInterestBase: JobProfileInterestBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interestId' is not null or undefined
            assertParamExists('userApiUpdateInterest', 'interestId', interestId)
            // verify required parameter 'jobProfileInterestBase' is not null or undefined
            assertParamExists('userApiUpdateInterest', 'jobProfileInterestBase', jobProfileInterestBase)
            const localVarPath = `/user/interest/{interest_id}`
                .replace('{interest_id}', encodeURIComponent(String(interestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfileInterestBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateJobApplicantsUserResumes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/applicants/populate/resume_ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<UpdateJobRoleBody>} updateJobRoleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateJobRole: async (updateJobRoleBody: Array<UpdateJobRoleBody>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateJobRoleBody' is not null or undefined
            assertParamExists('userApiUpdateJobRole', 'updateJobRoleBody', updateJobRoleBody)
            const localVarPath = `/admin/job-role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateJobRoleBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} languageId 
         * @param {JobProfileLanguageBase} jobProfileLanguageBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateLanguage: async (languageId: string, jobProfileLanguageBase: JobProfileLanguageBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'languageId' is not null or undefined
            assertParamExists('userApiUpdateLanguage', 'languageId', languageId)
            // verify required parameter 'jobProfileLanguageBase' is not null or undefined
            assertParamExists('userApiUpdateLanguage', 'jobProfileLanguageBase', jobProfileLanguageBase)
            const localVarPath = `/user/language/{language_id}`
                .replace('{language_id}', encodeURIComponent(String(languageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfileLanguageBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} positionId 
         * @param {JobProfilePositionOfResponsibilityBase} jobProfilePositionOfResponsibilityBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdatePositionOfResponsibility: async (positionId: string, jobProfilePositionOfResponsibilityBase: JobProfilePositionOfResponsibilityBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionId' is not null or undefined
            assertParamExists('userApiUpdatePositionOfResponsibility', 'positionId', positionId)
            // verify required parameter 'jobProfilePositionOfResponsibilityBase' is not null or undefined
            assertParamExists('userApiUpdatePositionOfResponsibility', 'jobProfilePositionOfResponsibilityBase', jobProfilePositionOfResponsibilityBase)
            const localVarPath = `/user/position-of-responsibility/{position_id}`
                .replace('{position_id}', encodeURIComponent(String(positionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfilePositionOfResponsibilityBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdatePractiseMetadata: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/practise-metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicationId 
         * @param {JobProfilePublicationBase} jobProfilePublicationBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdatePublication: async (publicationId: string, jobProfilePublicationBase: JobProfilePublicationBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicationId' is not null or undefined
            assertParamExists('userApiUpdatePublication', 'publicationId', publicationId)
            // verify required parameter 'jobProfilePublicationBase' is not null or undefined
            assertParamExists('userApiUpdatePublication', 'jobProfilePublicationBase', jobProfilePublicationBase)
            const localVarPath = `/user/publication/{publication_id}`
                .replace('{publication_id}', encodeURIComponent(String(publicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfilePublicationBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateReferralMultiplierBody} updateReferralMultiplierBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateReferralBaseMultiplier: async (updateReferralMultiplierBody: UpdateReferralMultiplierBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateReferralMultiplierBody' is not null or undefined
            assertParamExists('userApiUpdateReferralBaseMultiplier', 'updateReferralMultiplierBody', updateReferralMultiplierBody)
            const localVarPath = `/admin/referral-multiplier/base`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReferralMultiplierBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} milestoneId 
         * @param {UpdateReferralMilestoneBody} updateReferralMilestoneBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateReferralMilestone: async (milestoneId: string, updateReferralMilestoneBody: UpdateReferralMilestoneBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'milestoneId' is not null or undefined
            assertParamExists('userApiUpdateReferralMilestone', 'milestoneId', milestoneId)
            // verify required parameter 'updateReferralMilestoneBody' is not null or undefined
            assertParamExists('userApiUpdateReferralMilestone', 'updateReferralMilestoneBody', updateReferralMilestoneBody)
            const localVarPath = `/admin/referral-milestones/{milestone_id}`
                .replace('{milestone_id}', encodeURIComponent(String(milestoneId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReferralMilestoneBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeAccessId 
         * @param {ResumeShareBody} resumeShareBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateResumeAccess: async (resumeAccessId: string, resumeShareBody: ResumeShareBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeAccessId' is not null or undefined
            assertParamExists('userApiUpdateResumeAccess', 'resumeAccessId', resumeAccessId)
            // verify required parameter 'resumeShareBody' is not null or undefined
            assertParamExists('userApiUpdateResumeAccess', 'resumeShareBody', resumeShareBody)
            const localVarPath = `/user/resume_access/{resume_access_id}`
                .replace('{resume_access_id}', encodeURIComponent(String(resumeAccessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resumeShareBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateUserEmailBody} updateUserEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateUserEmail: async (updateUserEmailBody: UpdateUserEmailBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserEmailBody' is not null or undefined
            assertParamExists('userApiUpdateUserEmail', 'updateUserEmailBody', updateUserEmailBody)
            const localVarPath = `/user/update-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserEmailBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateUserBody} updateUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateUserProfile: async (updateUserBody: UpdateUserBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserBody' is not null or undefined
            assertParamExists('userApiUpdateUserProfile', 'updateUserBody', updateUserBody)
            const localVarPath = `/user-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeId 
         * @param {boolean} [isDefault] 
         * @param {string} [title] 
         * @param {string} [visibility] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateUserResumeVisibility: async (resumeId: string, isDefault?: boolean, title?: string, visibility?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeId' is not null or undefined
            assertParamExists('userApiUpdateUserResumeVisibility', 'resumeId', resumeId)
            const localVarPath = `/user/resume/{resume_id}`
                .replace('{resume_id}', encodeURIComponent(String(resumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDefault !== undefined) {
                localVarQueryParameter['is_default'] = isDefault;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (visibility !== undefined) {
                localVarQueryParameter['visibility'] = visibility;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OnboardingDoneBody} onboardingDoneBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateViewedTour: async (onboardingDoneBody: OnboardingDoneBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingDoneBody' is not null or undefined
            assertParamExists('userApiUpdateViewedTour', 'onboardingDoneBody', onboardingDoneBody)
            const localVarPath = `/user/viewed_tour`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardingDoneBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} volunteerId 
         * @param {JobProfileVolunteerExperienceBase} jobProfileVolunteerExperienceBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateVolunteerExperience: async (volunteerId: string, jobProfileVolunteerExperienceBase: JobProfileVolunteerExperienceBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'volunteerId' is not null or undefined
            assertParamExists('userApiUpdateVolunteerExperience', 'volunteerId', volunteerId)
            // verify required parameter 'jobProfileVolunteerExperienceBase' is not null or undefined
            assertParamExists('userApiUpdateVolunteerExperience', 'jobProfileVolunteerExperienceBase', jobProfileVolunteerExperienceBase)
            const localVarPath = `/user/volunteer-experience/{volunteer_id}`
                .replace('{volunteer_id}', encodeURIComponent(String(volunteerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfileVolunteerExperienceBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUploadExcelFile: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/upload_excel_file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} imageFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUploadMiscImage: async (imageFile: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageFile' is not null or undefined
            assertParamExists('userApiUploadMiscImage', 'imageFile', imageFile)
            const localVarPath = `/admin/upload-misc-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (imageFile !== undefined) { 
                localVarFormParams.append('image_file', imageFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} picture 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUploadUserProfilePicture: async (picture: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'picture' is not null or undefined
            assertParamExists('userApiUploadUserProfilePicture', 'picture', picture)
            const localVarPath = `/user-profile/picture`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (picture !== undefined) { 
                localVarFormParams.append('picture', picture as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<SocialLinksBody>} socialLinksBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpsertSocialLinks: async (socialLinksBody: Array<SocialLinksBody>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'socialLinksBody' is not null or undefined
            assertParamExists('userApiUpsertSocialLinks', 'socialLinksBody', socialLinksBody)
            const localVarPath = `/user/social_links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(socialLinksBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUserRequestedAccountDeletion: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/account-deletetion-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VerifyEmailOtpBody} verifyEmailOtpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiVerifyEmailOtp: async (verifyEmailOtpBody: VerifyEmailOtpBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyEmailOtpBody' is not null or undefined
            assertParamExists('userApiVerifyEmailOtp', 'verifyEmailOtpBody', verifyEmailOtpBody)
            const localVarPath = `/users/email-verify-otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyEmailOtpBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VerifyPhoneOtpBody} verifyPhoneOtpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiVerifyPhoneOtp: async (verifyPhoneOtpBody: VerifyPhoneOtpBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyPhoneOtpBody' is not null or undefined
            assertParamExists('userApiVerifyPhoneOtp', 'verifyPhoneOtpBody', verifyPhoneOtpBody)
            const localVarPath = `/users/phone-verify-otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyPhoneOtpBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WorkExperience} workExperience 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiWorkDetails: async (workExperience: WorkExperience, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workExperience' is not null or undefined
            assertParamExists('userApiWorkDetails', 'workExperience', workExperience)
            const localVarPath = `/user/work_details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workExperience, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApiApi - functional programming interface
 */
export const UserApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiActivateFreeAbekusPremium(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiActivateFreeAbekusPremium(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiActivateFreeAbekusPremium']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {JobProfileAwardBase} jobProfileAwardBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiAddAward(jobProfileAwardBase: JobProfileAwardBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateAwardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiAddAward(jobProfileAwardBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiAddAward']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {JobProfileCertificationBase} jobProfileCertificationBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiAddCertification(jobProfileCertificationBase: JobProfileCertificationBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateCertificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiAddCertification(jobProfileCertificationBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiAddCertification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} followedUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiAddFollowedUsers(followedUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FollowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiAddFollowedUsers(followedUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiAddFollowedUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {JobProfileInterestBase} jobProfileInterestBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiAddInterest(jobProfileInterestBase: JobProfileInterestBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateInterestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiAddInterest(jobProfileInterestBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiAddInterest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {JobProfileLanguageBase} jobProfileLanguageBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiAddLanguage(jobProfileLanguageBase: JobProfileLanguageBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateLanguageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiAddLanguage(jobProfileLanguageBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiAddLanguage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {JobProfilePositionOfResponsibilityBase} jobProfilePositionOfResponsibilityBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiAddPositionOfResponsibility(jobProfilePositionOfResponsibilityBase: JobProfilePositionOfResponsibilityBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePositionOfResponsibilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiAddPositionOfResponsibility(jobProfilePositionOfResponsibilityBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiAddPositionOfResponsibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {JobProfilePublicationBase} jobProfilePublicationBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiAddPublication(jobProfilePublicationBase: JobProfilePublicationBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePublicationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiAddPublication(jobProfilePublicationBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiAddPublication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {JobProfileVolunteerExperienceBase} jobProfileVolunteerExperienceBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiAddVolunteerExperience(jobProfileVolunteerExperienceBase: JobProfileVolunteerExperienceBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateVolunteerExperienceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiAddVolunteerExperience(jobProfileVolunteerExperienceBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiAddVolunteerExperience']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {AdminUserUpdateBody} adminUserUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiAdminUserUpdate(userId: string, adminUserUpdateBody: AdminUserUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiAdminUserUpdate(userId, adminUserUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiAdminUserUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AppleAuthMobileBody} appleAuthMobileBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiAppleAuthMobile(appleAuthMobileBody: AppleAuthMobileBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppleAuthMobileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiAppleAuthMobile(appleAuthMobileBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiAppleAuthMobile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiAutofillProfileFromResume(resumeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiAutofillProfileFromResume(resumeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiAutofillProfileFromResume']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IDListNumber} iDListNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiBulkPopulateUserResumes(iDListNumber: IDListNumber, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiBulkPopulateUserResumes(iDListNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiBulkPopulateUserResumes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} educationId 
         * @param {EducationDetails} educationDetails 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiChangeEducationDetails(educationId: string, educationDetails: EducationDetails, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEducationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiChangeEducationDetails(educationId, educationDetails, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiChangeEducationDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {JobProfileProject} jobProfileProject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiChangeProject(projectId: string, jobProfileProject: JobProfileProject, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateProjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiChangeProject(projectId, jobProfileProject, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiChangeProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ChangePasswordBody} changePasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiChangeUserPassword(changePasswordBody: ChangePasswordBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiChangeUserPassword(changePasswordBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiChangeUserPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiChangeUserType(userType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiChangeUserType(userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiChangeUserType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} workId 
         * @param {WorkExperience} workExperience 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiChangeWorkDetails(workId: string, workExperience: WorkExperience, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkExperienceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiChangeWorkDetails(workId, workExperience, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiChangeWorkDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiClearUserReferralMultiplier(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiClearUserReferralMultiplier(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiClearUserReferralMultiplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiCollegeAutocomplete(page?: number, pageSize?: number, query?: string, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollegeAutocompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiCollegeAutocomplete(page, pageSize, query, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiCollegeAutocomplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateCollegeBody} createCollegeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiCollegeDetails(createCollegeBody: CreateCollegeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateCollegeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiCollegeDetails(createCollegeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiCollegeDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiCompanyAutocomplete(page?: string, pageSize?: string, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyAutocompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiCompanyAutocomplete(page, pageSize, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiCompanyAutocomplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiCompanyCollegeDefaultColor(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiCompanyCollegeDefaultColor(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiCompanyCollegeDefaultColor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateCompanyBody} createCompanyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiCompanyDetails(createCompanyBody: CreateCompanyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateCompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiCompanyDetails(createCompanyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiCompanyDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreatePotentialRecruiterBody} createPotentialRecruiterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiCreateBulkPotentialRecruiters(createPotentialRecruiterBody: CreatePotentialRecruiterBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiCreateBulkPotentialRecruiters(createPotentialRecruiterBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiCreateBulkPotentialRecruiters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateJobRoleBody} createJobRoleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiCreateJobRole(createJobRoleBody: CreateJobRoleBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateJobRoleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiCreateJobRole(createJobRoleBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiCreateJobRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiCreateMissingUsernames(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiCreateMissingUsernames(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiCreateMissingUsernames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreatePotentialApplicantListBody} createPotentialApplicantListBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiCreatePotentialApplicantList(createPotentialApplicantListBody: CreatePotentialApplicantListBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePotentialApplicantListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiCreatePotentialApplicantList(createPotentialApplicantListBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiCreatePotentialApplicantList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreatePotentialApplicantsBody} createPotentialApplicantsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiCreatePotentialApplicants(createPotentialApplicantsBody: CreatePotentialApplicantsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePotentialApplicantsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiCreatePotentialApplicants(createPotentialApplicantsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiCreatePotentialApplicants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateReferralMilestoneBody} createReferralMilestoneBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiCreateReferralMilestone(createReferralMilestoneBody: CreateReferralMilestoneBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiCreateReferralMilestone(createReferralMilestoneBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiCreateReferralMilestone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateUserBody} createUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiCreateUser(createUserBody: CreateUserBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiCreateUser(createUserBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiCreateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customReferralsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteAdminCustomReferralList(customReferralsId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteAdminCustomReferralList(customReferralsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteAdminCustomReferralList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} awardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteAward(awardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteAward(awardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteAward']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} certId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteCertification(certId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteCertification(certId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteCertification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IDList} iDList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteCollege(iDList: IDList, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteCollege(iDList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteCollege']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IDList} iDList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteCompany(iDList: IDList, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkCompanyDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteCompany(iDList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} educationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteEducationDetails(educationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteEducationDetails(educationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteEducationDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteInactiveUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteInactiveUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteInactiveUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteInterest(interestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteInterest(interestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteInterest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IDList} iDList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteJobRole(iDList: IDList, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteJobRole(iDList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteJobRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} languageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteLanguage(languageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteLanguage(languageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteLanguage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteUserBody} deleteUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteMyUser(deleteUserBody: DeleteUserBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteMyUser(deleteUserBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteMyUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} positionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeletePositionOfResponsibility(positionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeletePositionOfResponsibility(positionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeletePositionOfResponsibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeletePotentialApplicantList(listId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeletePotentialApplicantList(listId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeletePotentialApplicantList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteProject(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteProject(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeletePublication(publicationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeletePublication(publicationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeletePublication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} milestoneId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteReferralMilestone(milestoneId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteReferralMilestone(milestoneId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteReferralMilestone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeAccessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteResumeAccess(resumeAccessId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteResumeAccess(resumeAccessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteResumeAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} socialLinkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteSocialLink(socialLinkId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteSocialLink(socialLinkId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteSocialLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteTempUserCompletely(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteTempUserCompletely(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteTempUserCompletely']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteUserCompletely(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteUserCompletely(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteUserCompletely']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteUserResume(resumeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteUserResume(resumeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteUserResume']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} volunteerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteVolunteerExperience(volunteerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteVolunteerExperience(volunteerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteVolunteerExperience']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} workId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiDeleteWorkDetails(workId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiDeleteWorkDetails(workId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiDeleteWorkDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EducationDetails} educationDetails 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiEducationDetails(educationDetails: EducationDetails, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEducationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiEducationDetails(educationDetails, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiEducationDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendEmailOtpBody} sendEmailOtpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiEmailActivation(sendEmailOtpBody: SendEmailOtpBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendEmailOtpRepsonse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiEmailActivation(sendEmailOtpBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiEmailActivation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiFetchResumeJson(resumeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResume>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiFetchResumeJson(resumeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiFetchResumeJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiFetchUserResumesJson(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResumeList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiFetchUserResumesJson(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiFetchUserResumesJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GAuthMobileBody} gAuthMobileBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGauthMobile(gAuthMobileBody: GAuthMobileBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GAuthMobileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGauthMobile(gAuthMobileBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGauthMobile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {JsonResumeGenerate} jsonResumeGenerate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGenerateResume(jsonResumeGenerate: JsonResumeGenerate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGenerateResume(jsonResumeGenerate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGenerateResume']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetAdminCustomReferralList(page?: number, pageSize?: number, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCustomReferralListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetAdminCustomReferralList(page, pageSize, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetAdminCustomReferralList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetAdminReferralMilestones(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllReferralMilestonesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetAdminReferralMilestones(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetAdminReferralMilestones']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetAdminReferralMultiplier(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReferralMultiplierResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetAdminReferralMultiplier(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetAdminReferralMultiplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetApplicantStatusInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetApplicantStatusInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetApplicantStatusInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetApplicantStatusInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [collegeId] 
         * @param {string} [collegeName] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [status] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetCollege(collegeId?: string, collegeName?: string, page?: number, pageSize?: number, sortBy?: string, sortOrder?: string, status?: string, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCollegesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetCollege(collegeId, collegeName, page, pageSize, sortBy, sortOrder, status, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetCollege']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [companyId] 
         * @param {string} [companyName] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [status] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetCompany(companyId?: string, companyName?: string, page?: number, pageSize?: number, sortBy?: string, sortOrder?: string, status?: string, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompanyResponseList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetCompany(companyId, companyName, page, pageSize, sortBy, sortOrder, status, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetEarnCreditsGoals(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EarnCreditsOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetEarnCreditsGoals(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetEarnCreditsGoals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetFeaturedCompanies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFeaturedCompaniesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetFeaturedCompanies(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetFeaturedCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetFollowedUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetFollowedUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetFollowedUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GemsActivityParam} gemsActivityParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetGemsActivity(gemsActivityParam: GemsActivityParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GemsActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetGemsActivity(gemsActivityParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetGemsActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [jobRoleId] 
         * @param {string} [pageNo] 
         * @param {string} [pageSize] 
         * @param {boolean} [showJobAssociatedRoles] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [status] 
         * @param {string} [userSearchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetJobRole(jobRoleId?: string, pageNo?: string, pageSize?: string, showJobAssociatedRoles?: boolean, sortBy?: string, sortOrder?: string, status?: string, userSearchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobRolesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetJobRole(jobRoleId, pageNo, pageSize, showJobAssociatedRoles, sortBy, sortOrder, status, userSearchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetJobRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [competitionId] 
         * @param {boolean} [onlyFollowed] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {boolean | null} [showUserRank] 
         * @param {string | null} [skillId] 
         * @param {string} [timePeriod] 
         * @param {string | null} [userSearchQuery] 
         * @param {string | null} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetLeaderboardByUser(competitionId?: string | null, onlyFollowed?: boolean, page?: number, pageSize?: number, showUserRank?: boolean | null, skillId?: string | null, timePeriod?: string, userSearchQuery?: string | null, userType?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompetitionLeaderboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetLeaderboardByUser(competitionId, onlyFollowed, page, pageSize, showUserRank, skillId, timePeriod, userSearchQuery, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetLeaderboardByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetMiniProfile(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileMiniResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetMiniProfile(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetMiniProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetMyBadges(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyBadgesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetMyBadges(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetMyBadges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [excludeInvited] 
         * @param {boolean} [forInvite] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [roomId] 
         * @param {Array<string>} [skillIds] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetOnlineUsers(excludeInvited?: boolean, forInvite?: boolean, page?: number, pageSize?: number, roomId?: string | null, skillIds?: Array<string>, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnlineUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetOnlineUsers(excludeInvited, forInvite, page, pageSize, roomId, skillIds, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetOnlineUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} field 
         * @param {boolean} [orderByMaxCount] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetPotentialApplicantFacetValues(field: string, orderByMaxCount?: boolean, page?: number, pageSize?: number, searchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PotentialApplicantFacetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetPotentialApplicantFacetValues(field, orderByMaxCount, page, pageSize, searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetPotentialApplicantFacetValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetPotentialApplicantLists(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPotentialApplicantListsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetPotentialApplicantLists(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetPotentialApplicantLists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetPotentialApplicantsBody} getPotentialApplicantsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetPotentialApplicants(getPotentialApplicantsBody: GetPotentialApplicantsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPotentialApplicantsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetPotentialApplicants(getPotentialApplicantsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetPotentialApplicants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [orderByMaxCount] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetPotentialApplicantsCourseSpecializations(orderByMaxCount?: boolean, page?: number, pageSize?: number, searchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PotentialApplicantsCourseSpecializationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetPotentialApplicantsCourseSpecializations(orderByMaxCount, page, pageSize, searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetPotentialApplicantsCourseSpecializations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [orderByMaxCount] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetPotentialApplicantsJobRoles(orderByMaxCount?: boolean, page?: number, pageSize?: number, searchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PotentialApplicantsJobRolesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetPotentialApplicantsJobRoles(orderByMaxCount, page, pageSize, searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetPotentialApplicantsJobRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetPotentialRecruiterCsvParam} getPotentialRecruiterCsvParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetPotentialRecruiterGoogleAdsMetadataCsv(getPotentialRecruiterCsvParam: GetPotentialRecruiterCsvParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetPotentialRecruiterGoogleAdsMetadataCsv(getPotentialRecruiterCsvParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetPotentialRecruiterGoogleAdsMetadataCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PotentialRecruiterParameter} potentialRecruiterParameter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetPotentialRecruiters(potentialRecruiterParameter: PotentialRecruiterParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPotentialRecruiterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetPotentialRecruiters(potentialRecruiterParameter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetPotentialRecruiters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [orderByMaxCount] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetPotentialRecruitersJobPostedCategories(orderByMaxCount?: boolean, page?: number, pageSize?: number, searchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PotentialRecruitersJobPostedCategoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetPotentialRecruitersJobPostedCategories(orderByMaxCount, page, pageSize, searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetPotentialRecruitersJobPostedCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetProfileCompletion(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileCompletionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetProfileCompletion(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetProfileCompletion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetPublicCommunityUpdatesActivity(page?: number, pageSize?: number, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicCommunityActivity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetPublicCommunityUpdatesActivity(page, pageSize, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetPublicCommunityUpdatesActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetQuestionAuthorList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetQuestionAuthorList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetQuestionAuthorList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} [endDate] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [startDate] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetReferralActivityLogs(userId: string, endDate?: string, page?: number, pageSize?: number, startDate?: string, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralActivityLogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetReferralActivityLogs(userId, endDate, page, pageSize, startDate, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetReferralActivityLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [hideReferredBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetReferralEmailPreview(hideReferredBy?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralEmailPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetReferralEmailPreview(hideReferredBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetReferralEmailPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [createdFrom] 
         * @param {string} [createdTo] 
         * @param {string} [lastReferredFrom] 
         * @param {string} [lastReferredTo] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetReferralSummary(createdFrom?: string, createdTo?: string, lastReferredFrom?: string, lastReferredTo?: string, page?: number, pageSize?: number, sortBy?: string, sortOrder?: string, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetReferralSummary(createdFrom, createdTo, lastReferredFrom, lastReferredTo, page, pageSize, sortBy, sortOrder, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetReferralSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetResumeAccessList(resumeId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetResumeAccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetResumeAccessList(resumeId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetResumeAccessList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetResumeActivity(resumeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetResumeActivity(resumeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetResumeActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} endDate 
         * @param {string} startDate 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetUserActivityCalendar(endDate: string, startDate: string, username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyScoreResponseSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetUserActivityCalendar(endDate, startDate, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetUserActivityCalendar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [domainId] 
         * @param {string} [onlyAttempted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetUserAnalytics(domainId?: string | null, onlyAttempted?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalyticsResponseSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetUserAnalytics(domainId, onlyAttempted, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetUserAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetUserCertificates(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserCertificatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetUserCertificates(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetUserCertificates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [skillId] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetUserCommunityUpdatesActivity(page?: number, pageSize?: number, skillId?: string | null, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserCommunityUpdatesActivity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetUserCommunityUpdatesActivity(page, pageSize, skillId, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetUserCommunityUpdatesActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [questionStatus] 
         * @param {string} [searchQuery] 
         * @param {Array<string>} [skillIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetUserCreatedQuestions(page?: number, pageSize?: number, questionStatus?: string, searchQuery?: string, skillIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserCreatedQuestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetUserCreatedQuestions(page, pageSize, questionStatus, searchQuery, skillIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetUserCreatedQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetUserDetails(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserDetailByEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetUserDetails(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetUserDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetUserFullJson(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetUserFullJson(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetUserFullJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetUserList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetUserList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetUserList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetUserLoginStreakDetails(endDate?: string, startDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginStreakResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetUserLoginStreakDetails(endDate, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetUserLoginStreakDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string | null} [endMonth] 
         * @param {number | null} [months] 
         * @param {string | null} [skillId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetUserMonthlyScore(username: string, endMonth?: string | null, months?: number | null, skillId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MonthlyScoreDataSub>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetUserMonthlyScore(username, endMonth, months, skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetUserMonthlyScore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {boolean} [onlyAnalytics] 
         * @param {boolean} [onlyAttempted] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetUserPublicProfile(username: string, onlyAnalytics?: boolean, onlyAttempted?: boolean, pageNo?: number, pageSize?: number, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicProfileAnalyticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetUserPublicProfile(username, onlyAnalytics, onlyAttempted, pageNo, pageSize, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetUserPublicProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetUserReferrals(page?: number, pageSize?: number, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserReferralsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetUserReferrals(page, pageSize, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetUserReferrals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetUserResumes(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetUserResumes(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetUserResumes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetUserSelf(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetUserSelf(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetUserSelf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetUserSelfResume(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetUserSelfResume(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetUserSelfResume']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiGetUsersJobReferralData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobReferralsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiGetUsersJobReferralData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiGetUsersJobReferralData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} listId 
         * @param {ImportPotentialApplicantListMembersBody} importPotentialApplicantListMembersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiImportPotentialApplicantListMembers(listId: string, importPotentialApplicantListMembersBody: ImportPotentialApplicantListMembersBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportPotentialApplicantListMembersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiImportPotentialApplicantListMembers(listId, importPotentialApplicantListMembersBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiImportPotentialApplicantListMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiIsUsernameAvailable(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IsUserAvailableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiIsUsernameAvailable(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiIsUsernameAvailable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [orderBy] 
         * @param {string} [pageNo] 
         * @param {string} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiJobRoleAutoComplete(orderBy?: string, pageNo?: string, pageSize?: string, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobRoleAutocompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiJobRoleAutoComplete(orderBy, pageNo, pageSize, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiJobRoleAutoComplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiLastAppliedPotentialApplicantJobRoles(searchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PotentialApplicantsWithAssociatedJobsAutocompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiLastAppliedPotentialApplicantJobRoles(searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiLastAppliedPotentialApplicantJobRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiMarkAutoApplyDialogShown(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiMarkAutoApplyDialogShown(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiMarkAutoApplyDialogShown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiMarkVoucherPopupDismissed(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiMarkVoucherPopupDismissed(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiMarkVoucherPopupDismissed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OnboardingDoneBody} onboardingDoneBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiOnboardingDone(onboardingDoneBody: OnboardingDoneBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingDoneResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiOnboardingDone(onboardingDoneBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiOnboardingDone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendPhoneOtpBodyBase} sendPhoneOtpBodyBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiPhoneActivation(sendPhoneOtpBodyBase: SendPhoneOtpBodyBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendPhoneOtpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiPhoneActivation(sendPhoneOtpBodyBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiPhoneActivation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminCustomReferralListBase} adminCustomReferralListBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiPostAdminCustomReferralList(adminCustomReferralListBase: AdminCustomReferralListBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiPostAdminCustomReferralList(adminCustomReferralListBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiPostAdminCustomReferralList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {JobProfileProject} jobProfileProject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiProject(jobProfileProject: JobProfileProject, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateProjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiProject(jobProfileProject, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RecordPendingAppReferralBody} recordPendingAppReferralBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiRecordPendingAppReferral(recordPendingAppReferralBody: RecordPendingAppReferralBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiRecordPendingAppReferral(recordPendingAppReferralBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiRecordPendingAppReferral']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiRecruiterDataNormalisation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiRecruiterDataNormalisation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiRecruiterDataNormalisation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReferByEmailBody} referByEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiReferByEmails(referByEmailBody: ReferByEmailBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferByEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiReferByEmails(referByEmailBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiReferByEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} followedUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiRemoveFollowedUsers(followedUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FollowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiRemoveFollowedUsers(followedUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiRemoveFollowedUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiResetUserCompletely(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiResetUserCompletely(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiResetUserCompletely']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiResetUserPassword(resetPasswordBody: ResetPasswordBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetPasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiResetUserPassword(resetPasswordBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiResetUserPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiResumeDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiResumeDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiResumeDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkResumeShareBody} bulkResumeShareBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiResumeShare(bulkResumeShareBody: BulkResumeShareBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkResumeShareResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiResumeShare(bulkResumeShareBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiResumeShare']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiResumeView(resumeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiResumeView(resumeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiResumeView']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RewardBonusBody} rewardBonusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiRewardBonusToUser(rewardBonusBody: RewardBonusBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiRewardBonusToUser(rewardBonusBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiRewardBonusToUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiSelectDomain(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiSelectDomain(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiSelectDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendEmailOtpBody} sendEmailOtpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiSendPasswordResetOtp(sendEmailOtpBody: SendEmailOtpBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendResetPasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiSendPasswordResetOtp(sendEmailOtpBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiSendPasswordResetOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} certificateId 
         * @param {CertificateVisibilityBody} certificateVisibilityBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiSetCertificateVisibility(certificateId: string, certificateVisibilityBody: CertificateVisibilityBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificateVisibilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiSetCertificateVisibility(certificateId, certificateVisibilityBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiSetCertificateVisibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DashboardPersonaBody} dashboardPersonaBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiSetDashboardPersona(dashboardPersonaBody: DashboardPersonaBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardPersonaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiSetDashboardPersona(dashboardPersonaBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiSetDashboardPersona']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SetNewPasswordBody} setNewPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiSetNewPassword(setNewPasswordBody: SetNewPasswordBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiSetNewPassword(setNewPasswordBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiSetNewPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {UpdateReferralMultiplierBody} updateReferralMultiplierBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiSetUserReferralMultiplier(userId: string, updateReferralMultiplierBody: UpdateReferralMultiplierBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiSetUserReferralMultiplier(userId, updateReferralMultiplierBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiSetUserReferralMultiplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SkipProfileItemBody} skipProfileItemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiSkipProfileCompletionItem(skipProfileItemBody: SkipProfileItemBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileCompletionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiSkipProfileCompletionItem(skipProfileItemBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiSkipProfileCompletionItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiToggleResumeLike(resumeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiToggleResumeLike(resumeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiToggleResumeLike']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customReferralsId 
         * @param {AdminCustomReferralListBase} adminCustomReferralListBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateAdminCustomReferralList(customReferralsId: string, adminCustomReferralListBase: AdminCustomReferralListBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateAdminCustomReferralList(customReferralsId, adminCustomReferralListBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateAdminCustomReferralList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateAutoPractiseMetadata(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateAutoPractiseMetadata(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateAutoPractiseMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} awardId 
         * @param {JobProfileAwardBase} jobProfileAwardBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateAward(awardId: string, jobProfileAwardBase: JobProfileAwardBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateAwardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateAward(awardId, jobProfileAwardBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateAward']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} certId 
         * @param {JobProfileCertificationBase} jobProfileCertificationBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateCertification(certId: string, jobProfileCertificationBase: JobProfileCertificationBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateCertificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateCertification(certId, jobProfileCertificationBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateCertification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} collegeId 
         * @param {string | null} [address] 
         * @param {string} [approvalStatus] 
         * @param {string | null} [collegeAdminId] 
         * @param {string} [collegeName] 
         * @param {string | null} [collegeType] 
         * @param {string | null} [defaultColor] 
         * @param {string | null} [description] 
         * @param {string | null} [directorName] 
         * @param {string | null} [districtName] 
         * @param {string | null} [email] 
         * @param {string | null} [imageUrl] 
         * @param {boolean} [isEmailVerified] 
         * @param {boolean} [isPhoneVerified] 
         * @param {string | null} [jointDirectorName] 
         * @param {string | null} [password] 
         * @param {string | null} [phoneNumber] 
         * @param {string | null} [stateName] 
         * @param {string | null} [universityName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateCollege(collegeId: string, address?: string | null, approvalStatus?: string, collegeAdminId?: string | null, collegeName?: string, collegeType?: string | null, defaultColor?: string | null, description?: string | null, directorName?: string | null, districtName?: string | null, email?: string | null, imageUrl?: string | null, isEmailVerified?: boolean, isPhoneVerified?: boolean, jointDirectorName?: string | null, password?: string | null, phoneNumber?: string | null, stateName?: string | null, universityName?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateCollegeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateCollege(collegeId, address, approvalStatus, collegeAdminId, collegeName, collegeType, defaultColor, description, directorName, districtName, email, imageUrl, isEmailVerified, isPhoneVerified, jointDirectorName, password, phoneNumber, stateName, universityName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateCollege']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string | null} [approvalStatus] 
         * @param {string | null} [companyDescription] 
         * @param {string | null} [companyName] 
         * @param {string | null} [companySize] 
         * @param {string | null} [corporateIdentificationNumber] 
         * @param {string | null} [defaultColor] 
         * @param {string | null} [imageUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateCompany(companyId: string, approvalStatus?: string | null, companyDescription?: string | null, companyName?: string | null, companySize?: string | null, corporateIdentificationNumber?: string | null, defaultColor?: string | null, imageUrl?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateCompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateCompany(companyId, approvalStatus, companyDescription, companyName, companySize, corporateIdentificationNumber, defaultColor, imageUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interestId 
         * @param {JobProfileInterestBase} jobProfileInterestBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateInterest(interestId: string, jobProfileInterestBase: JobProfileInterestBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateInterestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateInterest(interestId, jobProfileInterestBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateInterest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateJobApplicantsUserResumes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateApplicantUserResumeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateJobApplicantsUserResumes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateJobApplicantsUserResumes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<UpdateJobRoleBody>} updateJobRoleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateJobRole(updateJobRoleBody: Array<UpdateJobRoleBody>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateJobRoleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateJobRole(updateJobRoleBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateJobRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} languageId 
         * @param {JobProfileLanguageBase} jobProfileLanguageBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateLanguage(languageId: string, jobProfileLanguageBase: JobProfileLanguageBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateLanguageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateLanguage(languageId, jobProfileLanguageBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateLanguage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} positionId 
         * @param {JobProfilePositionOfResponsibilityBase} jobProfilePositionOfResponsibilityBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdatePositionOfResponsibility(positionId: string, jobProfilePositionOfResponsibilityBase: JobProfilePositionOfResponsibilityBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePositionOfResponsibilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdatePositionOfResponsibility(positionId, jobProfilePositionOfResponsibilityBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdatePositionOfResponsibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdatePractiseMetadata(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdatePractiseMetadata(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdatePractiseMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicationId 
         * @param {JobProfilePublicationBase} jobProfilePublicationBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdatePublication(publicationId: string, jobProfilePublicationBase: JobProfilePublicationBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePublicationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdatePublication(publicationId, jobProfilePublicationBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdatePublication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateReferralMultiplierBody} updateReferralMultiplierBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateReferralBaseMultiplier(updateReferralMultiplierBody: UpdateReferralMultiplierBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateReferralBaseMultiplier(updateReferralMultiplierBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateReferralBaseMultiplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} milestoneId 
         * @param {UpdateReferralMilestoneBody} updateReferralMilestoneBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateReferralMilestone(milestoneId: string, updateReferralMilestoneBody: UpdateReferralMilestoneBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateReferralMilestone(milestoneId, updateReferralMilestoneBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateReferralMilestone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeAccessId 
         * @param {ResumeShareBody} resumeShareBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateResumeAccess(resumeAccessId: string, resumeShareBody: ResumeShareBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateResumeAccess(resumeAccessId, resumeShareBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateResumeAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateUserEmailBody} updateUserEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateUserEmail(updateUserEmailBody: UpdateUserEmailBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateUserEmail(updateUserEmailBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateUserEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateUserBody} updateUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateUserProfile(updateUserBody: UpdateUserBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateUserProfile(updateUserBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeId 
         * @param {boolean} [isDefault] 
         * @param {string} [title] 
         * @param {string} [visibility] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateUserResumeVisibility(resumeId: string, isDefault?: boolean, title?: string, visibility?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResume>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateUserResumeVisibility(resumeId, isDefault, title, visibility, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateUserResumeVisibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OnboardingDoneBody} onboardingDoneBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateViewedTour(onboardingDoneBody: OnboardingDoneBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingDoneResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateViewedTour(onboardingDoneBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateViewedTour']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} volunteerId 
         * @param {JobProfileVolunteerExperienceBase} jobProfileVolunteerExperienceBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpdateVolunteerExperience(volunteerId: string, jobProfileVolunteerExperienceBase: JobProfileVolunteerExperienceBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateVolunteerExperienceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpdateVolunteerExperience(volunteerId, jobProfileVolunteerExperienceBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpdateVolunteerExperience']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUploadExcelFile(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUploadExcelFile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUploadExcelFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} imageFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUploadMiscImage(imageFile: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadMiscImageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUploadMiscImage(imageFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUploadMiscImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} picture 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUploadUserProfilePicture(picture: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfilePictureResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUploadUserProfilePicture(picture, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUploadUserProfilePicture']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<SocialLinksBody>} socialLinksBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUpsertSocialLinks(socialLinksBody: Array<SocialLinksBody>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SocialLinksResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUpsertSocialLinks(socialLinksBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUpsertSocialLinks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiUserRequestedAccountDeletion(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUserRequestedAccountDeletion(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiUserRequestedAccountDeletion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VerifyEmailOtpBody} verifyEmailOtpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiVerifyEmailOtp(verifyEmailOtpBody: VerifyEmailOtpBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyEmailOtpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiVerifyEmailOtp(verifyEmailOtpBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiVerifyEmailOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VerifyPhoneOtpBody} verifyPhoneOtpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiVerifyPhoneOtp(verifyPhoneOtpBody: VerifyPhoneOtpBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyPhoneOtpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiVerifyPhoneOtp(verifyPhoneOtpBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiVerifyPhoneOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WorkExperience} workExperience 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userApiWorkDetails(workExperience: WorkExperience, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkExperienceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userApiWorkDetails(workExperience, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApiApi.userApiWorkDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApiApi - factory interface
 */
export const UserApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiActivateFreeAbekusPremium(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiActivateFreeAbekusPremium(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiAddAwardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAddAward(requestParameters: UserApiApiUserApiAddAwardRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateAwardResponse> {
            return localVarFp.userApiAddAward(requestParameters.jobProfileAwardBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiAddCertificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAddCertification(requestParameters: UserApiApiUserApiAddCertificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateCertificationResponse> {
            return localVarFp.userApiAddCertification(requestParameters.jobProfileCertificationBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiAddFollowedUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAddFollowedUsers(requestParameters: UserApiApiUserApiAddFollowedUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<FollowResponse> {
            return localVarFp.userApiAddFollowedUsers(requestParameters.followedUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiAddInterestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAddInterest(requestParameters: UserApiApiUserApiAddInterestRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateInterestResponse> {
            return localVarFp.userApiAddInterest(requestParameters.jobProfileInterestBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiAddLanguageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAddLanguage(requestParameters: UserApiApiUserApiAddLanguageRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateLanguageResponse> {
            return localVarFp.userApiAddLanguage(requestParameters.jobProfileLanguageBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiAddPositionOfResponsibilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAddPositionOfResponsibility(requestParameters: UserApiApiUserApiAddPositionOfResponsibilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreatePositionOfResponsibilityResponse> {
            return localVarFp.userApiAddPositionOfResponsibility(requestParameters.jobProfilePositionOfResponsibilityBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiAddPublicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAddPublication(requestParameters: UserApiApiUserApiAddPublicationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreatePublicationResponse> {
            return localVarFp.userApiAddPublication(requestParameters.jobProfilePublicationBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiAddVolunteerExperienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAddVolunteerExperience(requestParameters: UserApiApiUserApiAddVolunteerExperienceRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateVolunteerExperienceResponse> {
            return localVarFp.userApiAddVolunteerExperience(requestParameters.jobProfileVolunteerExperienceBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiAdminUserUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAdminUserUpdate(requestParameters: UserApiApiUserApiAdminUserUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserUpdateResponse> {
            return localVarFp.userApiAdminUserUpdate(requestParameters.userId, requestParameters.adminUserUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiAppleAuthMobileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAppleAuthMobile(requestParameters: UserApiApiUserApiAppleAuthMobileRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppleAuthMobileResponse> {
            return localVarFp.userApiAppleAuthMobile(requestParameters.appleAuthMobileBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiAutofillProfileFromResumeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiAutofillProfileFromResume(requestParameters: UserApiApiUserApiAutofillProfileFromResumeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiAutofillProfileFromResume(requestParameters.resumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiBulkPopulateUserResumesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiBulkPopulateUserResumes(requestParameters: UserApiApiUserApiBulkPopulateUserResumesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiBulkPopulateUserResumes(requestParameters.iDListNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiChangeEducationDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiChangeEducationDetails(requestParameters: UserApiApiUserApiChangeEducationDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateEducationResponse> {
            return localVarFp.userApiChangeEducationDetails(requestParameters.educationId, requestParameters.educationDetails, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiChangeProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiChangeProject(requestParameters: UserApiApiUserApiChangeProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateProjectResponse> {
            return localVarFp.userApiChangeProject(requestParameters.projectId, requestParameters.jobProfileProject, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiChangeUserPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiChangeUserPassword(requestParameters: UserApiApiUserApiChangeUserPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiChangeUserPassword(requestParameters.changePasswordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiChangeUserTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiChangeUserType(requestParameters: UserApiApiUserApiChangeUserTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiChangeUserType(requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiChangeWorkDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiChangeWorkDetails(requestParameters: UserApiApiUserApiChangeWorkDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkExperienceResponse> {
            return localVarFp.userApiChangeWorkDetails(requestParameters.workId, requestParameters.workExperience, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiClearUserReferralMultiplierRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiClearUserReferralMultiplier(requestParameters: UserApiApiUserApiClearUserReferralMultiplierRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiClearUserReferralMultiplier(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiCollegeAutocompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCollegeAutocomplete(requestParameters: UserApiApiUserApiCollegeAutocompleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CollegeAutocompleteResponse> {
            return localVarFp.userApiCollegeAutocomplete(requestParameters.page, requestParameters.pageSize, requestParameters.query, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiCollegeDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCollegeDetails(requestParameters: UserApiApiUserApiCollegeDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateCollegeResponse> {
            return localVarFp.userApiCollegeDetails(requestParameters.createCollegeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiCompanyAutocompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCompanyAutocomplete(requestParameters: UserApiApiUserApiCompanyAutocompleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAutocompleteResponse> {
            return localVarFp.userApiCompanyAutocomplete(requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCompanyCollegeDefaultColor(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userApiCompanyCollegeDefaultColor(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiCompanyDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCompanyDetails(requestParameters: UserApiApiUserApiCompanyDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateCompanyResponse> {
            return localVarFp.userApiCompanyDetails(requestParameters.createCompanyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiCreateBulkPotentialRecruitersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCreateBulkPotentialRecruiters(requestParameters: UserApiApiUserApiCreateBulkPotentialRecruitersRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiCreateBulkPotentialRecruiters(requestParameters.createPotentialRecruiterBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiCreateJobRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCreateJobRole(requestParameters: UserApiApiUserApiCreateJobRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateJobRoleResponse> {
            return localVarFp.userApiCreateJobRole(requestParameters.createJobRoleBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCreateMissingUsernames(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userApiCreateMissingUsernames(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiCreatePotentialApplicantListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCreatePotentialApplicantList(requestParameters: UserApiApiUserApiCreatePotentialApplicantListRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreatePotentialApplicantListResponse> {
            return localVarFp.userApiCreatePotentialApplicantList(requestParameters.createPotentialApplicantListBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiCreatePotentialApplicantsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCreatePotentialApplicants(requestParameters: UserApiApiUserApiCreatePotentialApplicantsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreatePotentialApplicantsResponse> {
            return localVarFp.userApiCreatePotentialApplicants(requestParameters.createPotentialApplicantsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiCreateReferralMilestoneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCreateReferralMilestone(requestParameters: UserApiApiUserApiCreateReferralMilestoneRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiCreateReferralMilestone(requestParameters.createReferralMilestoneBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiCreateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiCreateUser(requestParameters: UserApiApiUserApiCreateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUserResponse> {
            return localVarFp.userApiCreateUser(requestParameters.createUserBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteAdminCustomReferralListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteAdminCustomReferralList(requestParameters: UserApiApiUserApiDeleteAdminCustomReferralListRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeleteAdminCustomReferralList(requestParameters.customReferralsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteAwardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteAward(requestParameters: UserApiApiUserApiDeleteAwardRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeleteAward(requestParameters.awardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteCertificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteCertification(requestParameters: UserApiApiUserApiDeleteCertificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeleteCertification(requestParameters.certId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteCollegeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteCollege(requestParameters: UserApiApiUserApiDeleteCollegeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeleteCollege(requestParameters.iDList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteCompany(requestParameters: UserApiApiUserApiDeleteCompanyRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkCompanyDeleteResponse> {
            return localVarFp.userApiDeleteCompany(requestParameters.iDList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteEducationDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteEducationDetails(requestParameters: UserApiApiUserApiDeleteEducationDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeleteEducationDetails(requestParameters.educationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteInactiveUsers(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userApiDeleteInactiveUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteInterestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteInterest(requestParameters: UserApiApiUserApiDeleteInterestRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeleteInterest(requestParameters.interestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteJobRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteJobRole(requestParameters: UserApiApiUserApiDeleteJobRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeleteJobRole(requestParameters.iDList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteLanguageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteLanguage(requestParameters: UserApiApiUserApiDeleteLanguageRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeleteLanguage(requestParameters.languageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteMyUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteMyUser(requestParameters: UserApiApiUserApiDeleteMyUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteUserResponse> {
            return localVarFp.userApiDeleteMyUser(requestParameters.deleteUserBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeletePositionOfResponsibilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeletePositionOfResponsibility(requestParameters: UserApiApiUserApiDeletePositionOfResponsibilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeletePositionOfResponsibility(requestParameters.positionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeletePotentialApplicantListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeletePotentialApplicantList(requestParameters: UserApiApiUserApiDeletePotentialApplicantListRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeletePotentialApplicantList(requestParameters.listId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteProject(requestParameters: UserApiApiUserApiDeleteProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeleteProject(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeletePublicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeletePublication(requestParameters: UserApiApiUserApiDeletePublicationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeletePublication(requestParameters.publicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteReferralMilestoneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteReferralMilestone(requestParameters: UserApiApiUserApiDeleteReferralMilestoneRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeleteReferralMilestone(requestParameters.milestoneId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteResumeAccessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteResumeAccess(requestParameters: UserApiApiUserApiDeleteResumeAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeleteResumeAccess(requestParameters.resumeAccessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteSocialLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteSocialLink(requestParameters: UserApiApiUserApiDeleteSocialLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeleteSocialLink(requestParameters.socialLinkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteTempUserCompletely(options?: RawAxiosRequestConfig): AxiosPromise<DeleteUserResponse> {
            return localVarFp.userApiDeleteTempUserCompletely(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteUserCompletelyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteUserCompletely(requestParameters: UserApiApiUserApiDeleteUserCompletelyRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteUserResponse> {
            return localVarFp.userApiDeleteUserCompletely(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteUserResumeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteUserResume(requestParameters: UserApiApiUserApiDeleteUserResumeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeleteUserResume(requestParameters.resumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteVolunteerExperienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteVolunteerExperience(requestParameters: UserApiApiUserApiDeleteVolunteerExperienceRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeleteVolunteerExperience(requestParameters.volunteerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiDeleteWorkDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiDeleteWorkDetails(requestParameters: UserApiApiUserApiDeleteWorkDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiDeleteWorkDetails(requestParameters.workId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiEducationDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiEducationDetails(requestParameters: UserApiApiUserApiEducationDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateEducationResponse> {
            return localVarFp.userApiEducationDetails(requestParameters.educationDetails, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiEmailActivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiEmailActivation(requestParameters: UserApiApiUserApiEmailActivationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendEmailOtpRepsonse> {
            return localVarFp.userApiEmailActivation(requestParameters.sendEmailOtpBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiFetchResumeJsonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiFetchResumeJson(requestParameters: UserApiApiUserApiFetchResumeJsonRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResume> {
            return localVarFp.userApiFetchResumeJson(requestParameters.resumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiFetchUserResumesJson(options?: RawAxiosRequestConfig): AxiosPromise<UserResumeList> {
            return localVarFp.userApiFetchUserResumesJson(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGauthMobileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGauthMobile(requestParameters: UserApiApiUserApiGauthMobileRequest, options?: RawAxiosRequestConfig): AxiosPromise<GAuthMobileResponse> {
            return localVarFp.userApiGauthMobile(requestParameters.gAuthMobileBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGenerateResumeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGenerateResume(requestParameters: UserApiApiUserApiGenerateResumeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiGenerateResume(requestParameters.jsonResumeGenerate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetAdminCustomReferralListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetAdminCustomReferralList(requestParameters: UserApiApiUserApiGetAdminCustomReferralListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminCustomReferralListResponse> {
            return localVarFp.userApiGetAdminCustomReferralList(requestParameters.page, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetAdminReferralMilestones(options?: RawAxiosRequestConfig): AxiosPromise<GetAllReferralMilestonesResponse> {
            return localVarFp.userApiGetAdminReferralMilestones(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetAdminReferralMultiplier(options?: RawAxiosRequestConfig): AxiosPromise<GetReferralMultiplierResponse> {
            return localVarFp.userApiGetAdminReferralMultiplier(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetApplicantStatusInfo(options?: RawAxiosRequestConfig): AxiosPromise<GetApplicantStatusInfo> {
            return localVarFp.userApiGetApplicantStatusInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetCollegeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetCollege(requestParameters: UserApiApiUserApiGetCollegeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCollegesResponse> {
            return localVarFp.userApiGetCollege(requestParameters.collegeId, requestParameters.collegeName, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.status, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetCompany(requestParameters: UserApiApiUserApiGetCompanyRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCompanyResponseList> {
            return localVarFp.userApiGetCompany(requestParameters.companyId, requestParameters.companyName, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.status, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetEarnCreditsGoals(options?: RawAxiosRequestConfig): AxiosPromise<EarnCreditsOverviewResponse> {
            return localVarFp.userApiGetEarnCreditsGoals(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetFeaturedCompanies(options?: RawAxiosRequestConfig): AxiosPromise<GetFeaturedCompaniesResponse> {
            return localVarFp.userApiGetFeaturedCompanies(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetFollowedUsers(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userApiGetFollowedUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetGemsActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetGemsActivity(requestParameters: UserApiApiUserApiGetGemsActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<GemsActivityResponse> {
            return localVarFp.userApiGetGemsActivity(requestParameters.gemsActivityParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetJobRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetJobRole(requestParameters: UserApiApiUserApiGetJobRoleRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetJobRolesResponse> {
            return localVarFp.userApiGetJobRole(requestParameters.jobRoleId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.showJobAssociatedRoles, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.status, requestParameters.userSearchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetLeaderboardByUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetLeaderboardByUser(requestParameters: UserApiApiUserApiGetLeaderboardByUserRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CompetitionLeaderboardResponse> {
            return localVarFp.userApiGetLeaderboardByUser(requestParameters.competitionId, requestParameters.onlyFollowed, requestParameters.page, requestParameters.pageSize, requestParameters.showUserRank, requestParameters.skillId, requestParameters.timePeriod, requestParameters.userSearchQuery, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetMiniProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetMiniProfile(requestParameters: UserApiApiUserApiGetMiniProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProfileMiniResponse> {
            return localVarFp.userApiGetMiniProfile(requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetMyBadges(options?: RawAxiosRequestConfig): AxiosPromise<MyBadgesResponse> {
            return localVarFp.userApiGetMyBadges(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetOnlineUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetOnlineUsers(requestParameters: UserApiApiUserApiGetOnlineUsersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OnlineUsersResponse> {
            return localVarFp.userApiGetOnlineUsers(requestParameters.excludeInvited, requestParameters.forInvite, requestParameters.page, requestParameters.pageSize, requestParameters.roomId, requestParameters.skillIds, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetPotentialApplicantFacetValuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPotentialApplicantFacetValues(requestParameters: UserApiApiUserApiGetPotentialApplicantFacetValuesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PotentialApplicantFacetResponse> {
            return localVarFp.userApiGetPotentialApplicantFacetValues(requestParameters.field, requestParameters.orderByMaxCount, requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPotentialApplicantLists(options?: RawAxiosRequestConfig): AxiosPromise<GetPotentialApplicantListsResponse> {
            return localVarFp.userApiGetPotentialApplicantLists(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetPotentialApplicantsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPotentialApplicants(requestParameters: UserApiApiUserApiGetPotentialApplicantsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPotentialApplicantsResponse> {
            return localVarFp.userApiGetPotentialApplicants(requestParameters.getPotentialApplicantsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetPotentialApplicantsCourseSpecializationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPotentialApplicantsCourseSpecializations(requestParameters: UserApiApiUserApiGetPotentialApplicantsCourseSpecializationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PotentialApplicantsCourseSpecializationsResponse> {
            return localVarFp.userApiGetPotentialApplicantsCourseSpecializations(requestParameters.orderByMaxCount, requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetPotentialApplicantsJobRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPotentialApplicantsJobRoles(requestParameters: UserApiApiUserApiGetPotentialApplicantsJobRolesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PotentialApplicantsJobRolesResponse> {
            return localVarFp.userApiGetPotentialApplicantsJobRoles(requestParameters.orderByMaxCount, requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetPotentialRecruiterGoogleAdsMetadataCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPotentialRecruiterGoogleAdsMetadataCsv(requestParameters: UserApiApiUserApiGetPotentialRecruiterGoogleAdsMetadataCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userApiGetPotentialRecruiterGoogleAdsMetadataCsv(requestParameters.getPotentialRecruiterCsvParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetPotentialRecruitersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPotentialRecruiters(requestParameters: UserApiApiUserApiGetPotentialRecruitersRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPotentialRecruiterResponse> {
            return localVarFp.userApiGetPotentialRecruiters(requestParameters.potentialRecruiterParameter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetPotentialRecruitersJobPostedCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPotentialRecruitersJobPostedCategories(requestParameters: UserApiApiUserApiGetPotentialRecruitersJobPostedCategoriesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PotentialRecruitersJobPostedCategoriesResponse> {
            return localVarFp.userApiGetPotentialRecruitersJobPostedCategories(requestParameters.orderByMaxCount, requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetProfileCompletion(options?: RawAxiosRequestConfig): AxiosPromise<ProfileCompletionResponse> {
            return localVarFp.userApiGetProfileCompletion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetPublicCommunityUpdatesActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetPublicCommunityUpdatesActivity(requestParameters: UserApiApiUserApiGetPublicCommunityUpdatesActivityRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PublicCommunityActivity> {
            return localVarFp.userApiGetPublicCommunityUpdatesActivity(requestParameters.page, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetQuestionAuthorList(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userApiGetQuestionAuthorList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetReferralActivityLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetReferralActivityLogs(requestParameters: UserApiApiUserApiGetReferralActivityLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReferralActivityLogResponse> {
            return localVarFp.userApiGetReferralActivityLogs(requestParameters.userId, requestParameters.endDate, requestParameters.page, requestParameters.pageSize, requestParameters.startDate, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetReferralEmailPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetReferralEmailPreview(requestParameters: UserApiApiUserApiGetReferralEmailPreviewRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ReferralEmailPreviewResponse> {
            return localVarFp.userApiGetReferralEmailPreview(requestParameters.hideReferredBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetReferralSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetReferralSummary(requestParameters: UserApiApiUserApiGetReferralSummaryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ReferralSummaryResponse> {
            return localVarFp.userApiGetReferralSummary(requestParameters.createdFrom, requestParameters.createdTo, requestParameters.lastReferredFrom, requestParameters.lastReferredTo, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetResumeAccessListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetResumeAccessList(requestParameters: UserApiApiUserApiGetResumeAccessListRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetResumeAccessResponse> {
            return localVarFp.userApiGetResumeAccessList(requestParameters.resumeId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetResumeActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetResumeActivity(requestParameters: UserApiApiUserApiGetResumeActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResumeActivityResponse> {
            return localVarFp.userApiGetResumeActivity(requestParameters.resumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetUserActivityCalendarRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserActivityCalendar(requestParameters: UserApiApiUserApiGetUserActivityCalendarRequest, options?: RawAxiosRequestConfig): AxiosPromise<DailyScoreResponseSub> {
            return localVarFp.userApiGetUserActivityCalendar(requestParameters.endDate, requestParameters.startDate, requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetUserAnalyticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserAnalytics(requestParameters: UserApiApiUserApiGetUserAnalyticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AnalyticsResponseSub> {
            return localVarFp.userApiGetUserAnalytics(requestParameters.domainId, requestParameters.onlyAttempted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetUserCertificatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserCertificates(requestParameters: UserApiApiUserApiGetUserCertificatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserCertificatesResponse> {
            return localVarFp.userApiGetUserCertificates(requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetUserCommunityUpdatesActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserCommunityUpdatesActivity(requestParameters: UserApiApiUserApiGetUserCommunityUpdatesActivityRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserCommunityUpdatesActivity> {
            return localVarFp.userApiGetUserCommunityUpdatesActivity(requestParameters.page, requestParameters.pageSize, requestParameters.skillId, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetUserCreatedQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserCreatedQuestions(requestParameters: UserApiApiUserApiGetUserCreatedQuestionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetUserCreatedQuestionResponse> {
            return localVarFp.userApiGetUserCreatedQuestions(requestParameters.page, requestParameters.pageSize, requestParameters.questionStatus, requestParameters.searchQuery, requestParameters.skillIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetUserDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserDetails(requestParameters: UserApiApiUserApiGetUserDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUserDetailByEmailResponse> {
            return localVarFp.userApiGetUserDetails(requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetUserFullJsonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserFullJson(requestParameters: UserApiApiUserApiGetUserFullJsonRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userApiGetUserFullJson(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserList(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userApiGetUserList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetUserLoginStreakDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserLoginStreakDetails(requestParameters: UserApiApiUserApiGetUserLoginStreakDetailsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LoginStreakResponse> {
            return localVarFp.userApiGetUserLoginStreakDetails(requestParameters.endDate, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetUserMonthlyScoreRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserMonthlyScore(requestParameters: UserApiApiUserApiGetUserMonthlyScoreRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MonthlyScoreDataSub>> {
            return localVarFp.userApiGetUserMonthlyScore(requestParameters.username, requestParameters.endMonth, requestParameters.months, requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetUserPublicProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserPublicProfile(requestParameters: UserApiApiUserApiGetUserPublicProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublicProfileAnalyticsResponse> {
            return localVarFp.userApiGetUserPublicProfile(requestParameters.username, requestParameters.onlyAnalytics, requestParameters.onlyAttempted, requestParameters.pageNo, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetUserReferralsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserReferrals(requestParameters: UserApiApiUserApiGetUserReferralsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserReferralsResponse> {
            return localVarFp.userApiGetUserReferrals(requestParameters.page, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiGetUserResumesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserResumes(requestParameters: UserApiApiUserApiGetUserResumesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userApiGetUserResumes(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserSelf(options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.userApiGetUserSelf(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUserSelfResume(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userApiGetUserSelfResume(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiGetUsersJobReferralData(options?: RawAxiosRequestConfig): AxiosPromise<GetJobReferralsResponse> {
            return localVarFp.userApiGetUsersJobReferralData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiImportPotentialApplicantListMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiImportPotentialApplicantListMembers(requestParameters: UserApiApiUserApiImportPotentialApplicantListMembersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportPotentialApplicantListMembersResponse> {
            return localVarFp.userApiImportPotentialApplicantListMembers(requestParameters.listId, requestParameters.importPotentialApplicantListMembersBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiIsUsernameAvailableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiIsUsernameAvailable(requestParameters: UserApiApiUserApiIsUsernameAvailableRequest, options?: RawAxiosRequestConfig): AxiosPromise<IsUserAvailableResponse> {
            return localVarFp.userApiIsUsernameAvailable(requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiJobRoleAutoCompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiJobRoleAutoComplete(requestParameters: UserApiApiUserApiJobRoleAutoCompleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<JobRoleAutocompleteResponse> {
            return localVarFp.userApiJobRoleAutoComplete(requestParameters.orderBy, requestParameters.pageNo, requestParameters.pageSize, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiLastAppliedPotentialApplicantJobRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiLastAppliedPotentialApplicantJobRoles(requestParameters: UserApiApiUserApiLastAppliedPotentialApplicantJobRolesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PotentialApplicantsWithAssociatedJobsAutocompleteResponse> {
            return localVarFp.userApiLastAppliedPotentialApplicantJobRoles(requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiMarkAutoApplyDialogShown(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiMarkAutoApplyDialogShown(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiMarkVoucherPopupDismissed(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiMarkVoucherPopupDismissed(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiOnboardingDoneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiOnboardingDone(requestParameters: UserApiApiUserApiOnboardingDoneRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingDoneResponse> {
            return localVarFp.userApiOnboardingDone(requestParameters.onboardingDoneBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiPhoneActivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiPhoneActivation(requestParameters: UserApiApiUserApiPhoneActivationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendPhoneOtpResponse> {
            return localVarFp.userApiPhoneActivation(requestParameters.sendPhoneOtpBodyBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiPostAdminCustomReferralListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiPostAdminCustomReferralList(requestParameters: UserApiApiUserApiPostAdminCustomReferralListRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiPostAdminCustomReferralList(requestParameters.adminCustomReferralListBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiProject(requestParameters: UserApiApiUserApiProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateProjectResponse> {
            return localVarFp.userApiProject(requestParameters.jobProfileProject, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiRecordPendingAppReferralRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiRecordPendingAppReferral(requestParameters: UserApiApiUserApiRecordPendingAppReferralRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiRecordPendingAppReferral(requestParameters.recordPendingAppReferralBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiRecruiterDataNormalisation(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiRecruiterDataNormalisation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiReferByEmailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiReferByEmails(requestParameters: UserApiApiUserApiReferByEmailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReferByEmailResponse> {
            return localVarFp.userApiReferByEmails(requestParameters.referByEmailBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiRemoveFollowedUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiRemoveFollowedUsers(requestParameters: UserApiApiUserApiRemoveFollowedUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<FollowResponse> {
            return localVarFp.userApiRemoveFollowedUsers(requestParameters.followedUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiResetUserCompletelyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiResetUserCompletely(requestParameters: UserApiApiUserApiResetUserCompletelyRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserResponse>> {
            return localVarFp.userApiResetUserCompletely(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiResetUserPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiResetUserPassword(requestParameters: UserApiApiUserApiResetUserPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResetPasswordResponse> {
            return localVarFp.userApiResetUserPassword(requestParameters.resetPasswordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiResumeDetails(options?: RawAxiosRequestConfig): AxiosPromise<ResumeResponse> {
            return localVarFp.userApiResumeDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiResumeShareRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiResumeShare(requestParameters: UserApiApiUserApiResumeShareRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkResumeShareResponse> {
            return localVarFp.userApiResumeShare(requestParameters.bulkResumeShareBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiResumeViewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiResumeView(requestParameters: UserApiApiUserApiResumeViewRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiResumeView(requestParameters.resumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiRewardBonusToUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiRewardBonusToUser(requestParameters: UserApiApiUserApiRewardBonusToUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiRewardBonusToUser(requestParameters.rewardBonusBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiSelectDomain(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userApiSelectDomain(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiSendPasswordResetOtpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiSendPasswordResetOtp(requestParameters: UserApiApiUserApiSendPasswordResetOtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendResetPasswordResponse> {
            return localVarFp.userApiSendPasswordResetOtp(requestParameters.sendEmailOtpBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiSetCertificateVisibilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiSetCertificateVisibility(requestParameters: UserApiApiUserApiSetCertificateVisibilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<CertificateVisibilityResponse> {
            return localVarFp.userApiSetCertificateVisibility(requestParameters.certificateId, requestParameters.certificateVisibilityBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiSetDashboardPersonaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiSetDashboardPersona(requestParameters: UserApiApiUserApiSetDashboardPersonaRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardPersonaResponse> {
            return localVarFp.userApiSetDashboardPersona(requestParameters.dashboardPersonaBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiSetNewPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiSetNewPassword(requestParameters: UserApiApiUserApiSetNewPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiSetNewPassword(requestParameters.setNewPasswordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiSetUserReferralMultiplierRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiSetUserReferralMultiplier(requestParameters: UserApiApiUserApiSetUserReferralMultiplierRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiSetUserReferralMultiplier(requestParameters.userId, requestParameters.updateReferralMultiplierBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiSkipProfileCompletionItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiSkipProfileCompletionItem(requestParameters: UserApiApiUserApiSkipProfileCompletionItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProfileCompletionResponse> {
            return localVarFp.userApiSkipProfileCompletionItem(requestParameters.skipProfileItemBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiToggleResumeLikeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiToggleResumeLike(requestParameters: UserApiApiUserApiToggleResumeLikeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiToggleResumeLike(requestParameters.resumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdateAdminCustomReferralListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateAdminCustomReferralList(requestParameters: UserApiApiUserApiUpdateAdminCustomReferralListRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiUpdateAdminCustomReferralList(requestParameters.customReferralsId, requestParameters.adminCustomReferralListBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateAutoPractiseMetadata(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userApiUpdateAutoPractiseMetadata(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdateAwardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateAward(requestParameters: UserApiApiUserApiUpdateAwardRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateAwardResponse> {
            return localVarFp.userApiUpdateAward(requestParameters.awardId, requestParameters.jobProfileAwardBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdateCertificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateCertification(requestParameters: UserApiApiUserApiUpdateCertificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateCertificationResponse> {
            return localVarFp.userApiUpdateCertification(requestParameters.certId, requestParameters.jobProfileCertificationBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdateCollegeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateCollege(requestParameters: UserApiApiUserApiUpdateCollegeRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateCollegeResponse> {
            return localVarFp.userApiUpdateCollege(requestParameters.collegeId, requestParameters.address, requestParameters.approvalStatus, requestParameters.collegeAdminId, requestParameters.collegeName, requestParameters.collegeType, requestParameters.defaultColor, requestParameters.description, requestParameters.directorName, requestParameters.districtName, requestParameters.email, requestParameters.imageUrl, requestParameters.isEmailVerified, requestParameters.isPhoneVerified, requestParameters.jointDirectorName, requestParameters.password, requestParameters.phoneNumber, requestParameters.stateName, requestParameters.universityName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdateCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateCompany(requestParameters: UserApiApiUserApiUpdateCompanyRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateCompanyResponse> {
            return localVarFp.userApiUpdateCompany(requestParameters.companyId, requestParameters.approvalStatus, requestParameters.companyDescription, requestParameters.companyName, requestParameters.companySize, requestParameters.corporateIdentificationNumber, requestParameters.defaultColor, requestParameters.imageUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdateInterestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateInterest(requestParameters: UserApiApiUserApiUpdateInterestRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateInterestResponse> {
            return localVarFp.userApiUpdateInterest(requestParameters.interestId, requestParameters.jobProfileInterestBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateJobApplicantsUserResumes(options?: RawAxiosRequestConfig): AxiosPromise<UpdateApplicantUserResumeResponse> {
            return localVarFp.userApiUpdateJobApplicantsUserResumes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdateJobRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateJobRole(requestParameters: UserApiApiUserApiUpdateJobRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateJobRoleResponse> {
            return localVarFp.userApiUpdateJobRole(requestParameters.updateJobRoleBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdateLanguageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateLanguage(requestParameters: UserApiApiUserApiUpdateLanguageRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateLanguageResponse> {
            return localVarFp.userApiUpdateLanguage(requestParameters.languageId, requestParameters.jobProfileLanguageBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdatePositionOfResponsibilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdatePositionOfResponsibility(requestParameters: UserApiApiUserApiUpdatePositionOfResponsibilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreatePositionOfResponsibilityResponse> {
            return localVarFp.userApiUpdatePositionOfResponsibility(requestParameters.positionId, requestParameters.jobProfilePositionOfResponsibilityBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdatePractiseMetadata(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userApiUpdatePractiseMetadata(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdatePublicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdatePublication(requestParameters: UserApiApiUserApiUpdatePublicationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreatePublicationResponse> {
            return localVarFp.userApiUpdatePublication(requestParameters.publicationId, requestParameters.jobProfilePublicationBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdateReferralBaseMultiplierRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateReferralBaseMultiplier(requestParameters: UserApiApiUserApiUpdateReferralBaseMultiplierRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiUpdateReferralBaseMultiplier(requestParameters.updateReferralMultiplierBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdateReferralMilestoneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateReferralMilestone(requestParameters: UserApiApiUserApiUpdateReferralMilestoneRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiUpdateReferralMilestone(requestParameters.milestoneId, requestParameters.updateReferralMilestoneBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdateResumeAccessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateResumeAccess(requestParameters: UserApiApiUserApiUpdateResumeAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiUpdateResumeAccess(requestParameters.resumeAccessId, requestParameters.resumeShareBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdateUserEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateUserEmail(requestParameters: UserApiApiUserApiUpdateUserEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiUpdateUserEmail(requestParameters.updateUserEmailBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdateUserProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateUserProfile(requestParameters: UserApiApiUserApiUpdateUserProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.userApiUpdateUserProfile(requestParameters.updateUserBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdateUserResumeVisibilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateUserResumeVisibility(requestParameters: UserApiApiUserApiUpdateUserResumeVisibilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResume> {
            return localVarFp.userApiUpdateUserResumeVisibility(requestParameters.resumeId, requestParameters.isDefault, requestParameters.title, requestParameters.visibility, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdateViewedTourRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateViewedTour(requestParameters: UserApiApiUserApiUpdateViewedTourRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingDoneResponse> {
            return localVarFp.userApiUpdateViewedTour(requestParameters.onboardingDoneBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpdateVolunteerExperienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpdateVolunteerExperience(requestParameters: UserApiApiUserApiUpdateVolunteerExperienceRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateVolunteerExperienceResponse> {
            return localVarFp.userApiUpdateVolunteerExperience(requestParameters.volunteerId, requestParameters.jobProfileVolunteerExperienceBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUploadExcelFile(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userApiUploadExcelFile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUploadMiscImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUploadMiscImage(requestParameters: UserApiApiUserApiUploadMiscImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadMiscImageResponse> {
            return localVarFp.userApiUploadMiscImage(requestParameters.imageFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUploadUserProfilePictureRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUploadUserProfilePicture(requestParameters: UserApiApiUserApiUploadUserProfilePictureRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProfilePictureResponse> {
            return localVarFp.userApiUploadUserProfilePicture(requestParameters.picture, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiUpsertSocialLinksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUpsertSocialLinks(requestParameters: UserApiApiUserApiUpsertSocialLinksRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SocialLinksResponse>> {
            return localVarFp.userApiUpsertSocialLinks(requestParameters.socialLinksBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiUserRequestedAccountDeletion(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userApiUserRequestedAccountDeletion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiVerifyEmailOtpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiVerifyEmailOtp(requestParameters: UserApiApiUserApiVerifyEmailOtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<VerifyEmailOtpResponse> {
            return localVarFp.userApiVerifyEmailOtp(requestParameters.verifyEmailOtpBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiVerifyPhoneOtpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiVerifyPhoneOtp(requestParameters: UserApiApiUserApiVerifyPhoneOtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<VerifyPhoneOtpResponse> {
            return localVarFp.userApiVerifyPhoneOtp(requestParameters.verifyPhoneOtpBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiApiUserApiWorkDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userApiWorkDetails(requestParameters: UserApiApiUserApiWorkDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkExperienceResponse> {
            return localVarFp.userApiWorkDetails(requestParameters.workExperience, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for userApiAddAward operation in UserApiApi.
 */
export interface UserApiApiUserApiAddAwardRequest {
    readonly jobProfileAwardBase: JobProfileAwardBase
}

/**
 * Request parameters for userApiAddCertification operation in UserApiApi.
 */
export interface UserApiApiUserApiAddCertificationRequest {
    readonly jobProfileCertificationBase: JobProfileCertificationBase
}

/**
 * Request parameters for userApiAddFollowedUsers operation in UserApiApi.
 */
export interface UserApiApiUserApiAddFollowedUsersRequest {
    readonly followedUserId: string
}

/**
 * Request parameters for userApiAddInterest operation in UserApiApi.
 */
export interface UserApiApiUserApiAddInterestRequest {
    readonly jobProfileInterestBase: JobProfileInterestBase
}

/**
 * Request parameters for userApiAddLanguage operation in UserApiApi.
 */
export interface UserApiApiUserApiAddLanguageRequest {
    readonly jobProfileLanguageBase: JobProfileLanguageBase
}

/**
 * Request parameters for userApiAddPositionOfResponsibility operation in UserApiApi.
 */
export interface UserApiApiUserApiAddPositionOfResponsibilityRequest {
    readonly jobProfilePositionOfResponsibilityBase: JobProfilePositionOfResponsibilityBase
}

/**
 * Request parameters for userApiAddPublication operation in UserApiApi.
 */
export interface UserApiApiUserApiAddPublicationRequest {
    readonly jobProfilePublicationBase: JobProfilePublicationBase
}

/**
 * Request parameters for userApiAddVolunteerExperience operation in UserApiApi.
 */
export interface UserApiApiUserApiAddVolunteerExperienceRequest {
    readonly jobProfileVolunteerExperienceBase: JobProfileVolunteerExperienceBase
}

/**
 * Request parameters for userApiAdminUserUpdate operation in UserApiApi.
 */
export interface UserApiApiUserApiAdminUserUpdateRequest {
    readonly userId: string

    readonly adminUserUpdateBody: AdminUserUpdateBody
}

/**
 * Request parameters for userApiAppleAuthMobile operation in UserApiApi.
 */
export interface UserApiApiUserApiAppleAuthMobileRequest {
    readonly appleAuthMobileBody: AppleAuthMobileBody
}

/**
 * Request parameters for userApiAutofillProfileFromResume operation in UserApiApi.
 */
export interface UserApiApiUserApiAutofillProfileFromResumeRequest {
    readonly resumeId: string
}

/**
 * Request parameters for userApiBulkPopulateUserResumes operation in UserApiApi.
 */
export interface UserApiApiUserApiBulkPopulateUserResumesRequest {
    readonly iDListNumber: IDListNumber
}

/**
 * Request parameters for userApiChangeEducationDetails operation in UserApiApi.
 */
export interface UserApiApiUserApiChangeEducationDetailsRequest {
    readonly educationId: string

    readonly educationDetails: EducationDetails
}

/**
 * Request parameters for userApiChangeProject operation in UserApiApi.
 */
export interface UserApiApiUserApiChangeProjectRequest {
    readonly projectId: string

    readonly jobProfileProject: JobProfileProject
}

/**
 * Request parameters for userApiChangeUserPassword operation in UserApiApi.
 */
export interface UserApiApiUserApiChangeUserPasswordRequest {
    readonly changePasswordBody: ChangePasswordBody
}

/**
 * Request parameters for userApiChangeUserType operation in UserApiApi.
 */
export interface UserApiApiUserApiChangeUserTypeRequest {
    readonly userType: string
}

/**
 * Request parameters for userApiChangeWorkDetails operation in UserApiApi.
 */
export interface UserApiApiUserApiChangeWorkDetailsRequest {
    readonly workId: string

    readonly workExperience: WorkExperience
}

/**
 * Request parameters for userApiClearUserReferralMultiplier operation in UserApiApi.
 */
export interface UserApiApiUserApiClearUserReferralMultiplierRequest {
    readonly userId: string
}

/**
 * Request parameters for userApiCollegeAutocomplete operation in UserApiApi.
 */
export interface UserApiApiUserApiCollegeAutocompleteRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly query?: string

    readonly totalPages?: number
}

/**
 * Request parameters for userApiCollegeDetails operation in UserApiApi.
 */
export interface UserApiApiUserApiCollegeDetailsRequest {
    readonly createCollegeBody: CreateCollegeBody
}

/**
 * Request parameters for userApiCompanyAutocomplete operation in UserApiApi.
 */
export interface UserApiApiUserApiCompanyAutocompleteRequest {
    readonly page?: string

    readonly pageSize?: string

    readonly query?: string
}

/**
 * Request parameters for userApiCompanyDetails operation in UserApiApi.
 */
export interface UserApiApiUserApiCompanyDetailsRequest {
    readonly createCompanyBody: CreateCompanyBody
}

/**
 * Request parameters for userApiCreateBulkPotentialRecruiters operation in UserApiApi.
 */
export interface UserApiApiUserApiCreateBulkPotentialRecruitersRequest {
    readonly createPotentialRecruiterBody: CreatePotentialRecruiterBody
}

/**
 * Request parameters for userApiCreateJobRole operation in UserApiApi.
 */
export interface UserApiApiUserApiCreateJobRoleRequest {
    readonly createJobRoleBody: CreateJobRoleBody
}

/**
 * Request parameters for userApiCreatePotentialApplicantList operation in UserApiApi.
 */
export interface UserApiApiUserApiCreatePotentialApplicantListRequest {
    readonly createPotentialApplicantListBody: CreatePotentialApplicantListBody
}

/**
 * Request parameters for userApiCreatePotentialApplicants operation in UserApiApi.
 */
export interface UserApiApiUserApiCreatePotentialApplicantsRequest {
    readonly createPotentialApplicantsBody: CreatePotentialApplicantsBody
}

/**
 * Request parameters for userApiCreateReferralMilestone operation in UserApiApi.
 */
export interface UserApiApiUserApiCreateReferralMilestoneRequest {
    readonly createReferralMilestoneBody: CreateReferralMilestoneBody
}

/**
 * Request parameters for userApiCreateUser operation in UserApiApi.
 */
export interface UserApiApiUserApiCreateUserRequest {
    readonly createUserBody: CreateUserBody
}

/**
 * Request parameters for userApiDeleteAdminCustomReferralList operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteAdminCustomReferralListRequest {
    readonly customReferralsId: string
}

/**
 * Request parameters for userApiDeleteAward operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteAwardRequest {
    readonly awardId: string
}

/**
 * Request parameters for userApiDeleteCertification operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteCertificationRequest {
    readonly certId: string
}

/**
 * Request parameters for userApiDeleteCollege operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteCollegeRequest {
    readonly iDList: IDList
}

/**
 * Request parameters for userApiDeleteCompany operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteCompanyRequest {
    readonly iDList: IDList
}

/**
 * Request parameters for userApiDeleteEducationDetails operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteEducationDetailsRequest {
    readonly educationId: string
}

/**
 * Request parameters for userApiDeleteInterest operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteInterestRequest {
    readonly interestId: string
}

/**
 * Request parameters for userApiDeleteJobRole operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteJobRoleRequest {
    readonly iDList: IDList
}

/**
 * Request parameters for userApiDeleteLanguage operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteLanguageRequest {
    readonly languageId: string
}

/**
 * Request parameters for userApiDeleteMyUser operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteMyUserRequest {
    readonly deleteUserBody: DeleteUserBody
}

/**
 * Request parameters for userApiDeletePositionOfResponsibility operation in UserApiApi.
 */
export interface UserApiApiUserApiDeletePositionOfResponsibilityRequest {
    readonly positionId: string
}

/**
 * Request parameters for userApiDeletePotentialApplicantList operation in UserApiApi.
 */
export interface UserApiApiUserApiDeletePotentialApplicantListRequest {
    readonly listId: string
}

/**
 * Request parameters for userApiDeleteProject operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteProjectRequest {
    readonly projectId: string
}

/**
 * Request parameters for userApiDeletePublication operation in UserApiApi.
 */
export interface UserApiApiUserApiDeletePublicationRequest {
    readonly publicationId: string
}

/**
 * Request parameters for userApiDeleteReferralMilestone operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteReferralMilestoneRequest {
    readonly milestoneId: string
}

/**
 * Request parameters for userApiDeleteResumeAccess operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteResumeAccessRequest {
    readonly resumeAccessId: string
}

/**
 * Request parameters for userApiDeleteSocialLink operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteSocialLinkRequest {
    readonly socialLinkId: string
}

/**
 * Request parameters for userApiDeleteUserCompletely operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteUserCompletelyRequest {
    readonly userId: string
}

/**
 * Request parameters for userApiDeleteUserResume operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteUserResumeRequest {
    readonly resumeId: string
}

/**
 * Request parameters for userApiDeleteVolunteerExperience operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteVolunteerExperienceRequest {
    readonly volunteerId: string
}

/**
 * Request parameters for userApiDeleteWorkDetails operation in UserApiApi.
 */
export interface UserApiApiUserApiDeleteWorkDetailsRequest {
    readonly workId: string
}

/**
 * Request parameters for userApiEducationDetails operation in UserApiApi.
 */
export interface UserApiApiUserApiEducationDetailsRequest {
    readonly educationDetails: EducationDetails
}

/**
 * Request parameters for userApiEmailActivation operation in UserApiApi.
 */
export interface UserApiApiUserApiEmailActivationRequest {
    readonly sendEmailOtpBody: SendEmailOtpBody
}

/**
 * Request parameters for userApiFetchResumeJson operation in UserApiApi.
 */
export interface UserApiApiUserApiFetchResumeJsonRequest {
    readonly resumeId: string
}

/**
 * Request parameters for userApiGauthMobile operation in UserApiApi.
 */
export interface UserApiApiUserApiGauthMobileRequest {
    readonly gAuthMobileBody: GAuthMobileBody
}

/**
 * Request parameters for userApiGenerateResume operation in UserApiApi.
 */
export interface UserApiApiUserApiGenerateResumeRequest {
    readonly jsonResumeGenerate: JsonResumeGenerate
}

/**
 * Request parameters for userApiGetAdminCustomReferralList operation in UserApiApi.
 */
export interface UserApiApiUserApiGetAdminCustomReferralListRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly totalPages?: number
}

/**
 * Request parameters for userApiGetCollege operation in UserApiApi.
 */
export interface UserApiApiUserApiGetCollegeRequest {
    readonly collegeId?: string

    readonly collegeName?: string

    readonly page?: number

    readonly pageSize?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly status?: string

    readonly totalPages?: number
}

/**
 * Request parameters for userApiGetCompany operation in UserApiApi.
 */
export interface UserApiApiUserApiGetCompanyRequest {
    readonly companyId?: string

    readonly companyName?: string

    readonly page?: number

    readonly pageSize?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly status?: string

    readonly totalPages?: number
}

/**
 * Request parameters for userApiGetGemsActivity operation in UserApiApi.
 */
export interface UserApiApiUserApiGetGemsActivityRequest {
    readonly gemsActivityParam: GemsActivityParam
}

/**
 * Request parameters for userApiGetJobRole operation in UserApiApi.
 */
export interface UserApiApiUserApiGetJobRoleRequest {
    readonly jobRoleId?: string

    readonly pageNo?: string

    readonly pageSize?: string

    readonly showJobAssociatedRoles?: boolean

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly status?: string

    readonly userSearchQuery?: string
}

/**
 * Request parameters for userApiGetLeaderboardByUser operation in UserApiApi.
 */
export interface UserApiApiUserApiGetLeaderboardByUserRequest {
    readonly competitionId?: string | null

    readonly onlyFollowed?: boolean

    readonly page?: number

    readonly pageSize?: number

    readonly showUserRank?: boolean | null

    readonly skillId?: string | null

    readonly timePeriod?: string

    readonly userSearchQuery?: string | null

    readonly userType?: string | null
}

/**
 * Request parameters for userApiGetMiniProfile operation in UserApiApi.
 */
export interface UserApiApiUserApiGetMiniProfileRequest {
    readonly username: string
}

/**
 * Request parameters for userApiGetOnlineUsers operation in UserApiApi.
 */
export interface UserApiApiUserApiGetOnlineUsersRequest {
    readonly excludeInvited?: boolean

    readonly forInvite?: boolean

    readonly page?: number

    readonly pageSize?: number

    readonly roomId?: string | null

    readonly skillIds?: Array<string>

    readonly totalPages?: number
}

/**
 * Request parameters for userApiGetPotentialApplicantFacetValues operation in UserApiApi.
 */
export interface UserApiApiUserApiGetPotentialApplicantFacetValuesRequest {
    readonly field: string

    readonly orderByMaxCount?: boolean

    readonly page?: number

    readonly pageSize?: number

    readonly searchQuery?: string
}

/**
 * Request parameters for userApiGetPotentialApplicants operation in UserApiApi.
 */
export interface UserApiApiUserApiGetPotentialApplicantsRequest {
    readonly getPotentialApplicantsBody: GetPotentialApplicantsBody
}

/**
 * Request parameters for userApiGetPotentialApplicantsCourseSpecializations operation in UserApiApi.
 */
export interface UserApiApiUserApiGetPotentialApplicantsCourseSpecializationsRequest {
    readonly orderByMaxCount?: boolean

    readonly page?: number

    readonly pageSize?: number

    readonly searchQuery?: string
}

/**
 * Request parameters for userApiGetPotentialApplicantsJobRoles operation in UserApiApi.
 */
export interface UserApiApiUserApiGetPotentialApplicantsJobRolesRequest {
    readonly orderByMaxCount?: boolean

    readonly page?: number

    readonly pageSize?: number

    readonly searchQuery?: string
}

/**
 * Request parameters for userApiGetPotentialRecruiterGoogleAdsMetadataCsv operation in UserApiApi.
 */
export interface UserApiApiUserApiGetPotentialRecruiterGoogleAdsMetadataCsvRequest {
    readonly getPotentialRecruiterCsvParam: GetPotentialRecruiterCsvParam
}

/**
 * Request parameters for userApiGetPotentialRecruiters operation in UserApiApi.
 */
export interface UserApiApiUserApiGetPotentialRecruitersRequest {
    readonly potentialRecruiterParameter: PotentialRecruiterParameter
}

/**
 * Request parameters for userApiGetPotentialRecruitersJobPostedCategories operation in UserApiApi.
 */
export interface UserApiApiUserApiGetPotentialRecruitersJobPostedCategoriesRequest {
    readonly orderByMaxCount?: boolean

    readonly page?: number

    readonly pageSize?: number

    readonly searchQuery?: string
}

/**
 * Request parameters for userApiGetPublicCommunityUpdatesActivity operation in UserApiApi.
 */
export interface UserApiApiUserApiGetPublicCommunityUpdatesActivityRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly totalPages?: number
}

/**
 * Request parameters for userApiGetReferralActivityLogs operation in UserApiApi.
 */
export interface UserApiApiUserApiGetReferralActivityLogsRequest {
    readonly userId: string

    readonly endDate?: string

    readonly page?: number

    readonly pageSize?: number

    readonly startDate?: string

    readonly totalPages?: number
}

/**
 * Request parameters for userApiGetReferralEmailPreview operation in UserApiApi.
 */
export interface UserApiApiUserApiGetReferralEmailPreviewRequest {
    readonly hideReferredBy?: boolean
}

/**
 * Request parameters for userApiGetReferralSummary operation in UserApiApi.
 */
export interface UserApiApiUserApiGetReferralSummaryRequest {
    readonly createdFrom?: string

    readonly createdTo?: string

    readonly lastReferredFrom?: string

    readonly lastReferredTo?: string

    readonly page?: number

    readonly pageSize?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly totalPages?: number
}

/**
 * Request parameters for userApiGetResumeAccessList operation in UserApiApi.
 */
export interface UserApiApiUserApiGetResumeAccessListRequest {
    readonly resumeId: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for userApiGetResumeActivity operation in UserApiApi.
 */
export interface UserApiApiUserApiGetResumeActivityRequest {
    readonly resumeId: string
}

/**
 * Request parameters for userApiGetUserActivityCalendar operation in UserApiApi.
 */
export interface UserApiApiUserApiGetUserActivityCalendarRequest {
    readonly endDate: string

    readonly startDate: string

    readonly username: string
}

/**
 * Request parameters for userApiGetUserAnalytics operation in UserApiApi.
 */
export interface UserApiApiUserApiGetUserAnalyticsRequest {
    readonly domainId?: string | null

    readonly onlyAttempted?: string
}

/**
 * Request parameters for userApiGetUserCertificates operation in UserApiApi.
 */
export interface UserApiApiUserApiGetUserCertificatesRequest {
    readonly username: string
}

/**
 * Request parameters for userApiGetUserCommunityUpdatesActivity operation in UserApiApi.
 */
export interface UserApiApiUserApiGetUserCommunityUpdatesActivityRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly skillId?: string | null

    readonly totalPages?: number
}

/**
 * Request parameters for userApiGetUserCreatedQuestions operation in UserApiApi.
 */
export interface UserApiApiUserApiGetUserCreatedQuestionsRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly questionStatus?: string

    readonly searchQuery?: string

    readonly skillIds?: Array<string>
}

/**
 * Request parameters for userApiGetUserDetails operation in UserApiApi.
 */
export interface UserApiApiUserApiGetUserDetailsRequest {
    readonly email: string
}

/**
 * Request parameters for userApiGetUserFullJson operation in UserApiApi.
 */
export interface UserApiApiUserApiGetUserFullJsonRequest {
    readonly userId: string
}

/**
 * Request parameters for userApiGetUserLoginStreakDetails operation in UserApiApi.
 */
export interface UserApiApiUserApiGetUserLoginStreakDetailsRequest {
    readonly endDate?: string

    readonly startDate?: string
}

/**
 * Request parameters for userApiGetUserMonthlyScore operation in UserApiApi.
 */
export interface UserApiApiUserApiGetUserMonthlyScoreRequest {
    readonly username: string

    readonly endMonth?: string | null

    readonly months?: number | null

    readonly skillId?: string | null
}

/**
 * Request parameters for userApiGetUserPublicProfile operation in UserApiApi.
 */
export interface UserApiApiUserApiGetUserPublicProfileRequest {
    readonly username: string

    readonly onlyAnalytics?: boolean

    readonly onlyAttempted?: boolean

    readonly pageNo?: number

    readonly pageSize?: number

    readonly totalPages?: number
}

/**
 * Request parameters for userApiGetUserReferrals operation in UserApiApi.
 */
export interface UserApiApiUserApiGetUserReferralsRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly totalPages?: number
}

/**
 * Request parameters for userApiGetUserResumes operation in UserApiApi.
 */
export interface UserApiApiUserApiGetUserResumesRequest {
    readonly userId: string
}

/**
 * Request parameters for userApiImportPotentialApplicantListMembers operation in UserApiApi.
 */
export interface UserApiApiUserApiImportPotentialApplicantListMembersRequest {
    readonly listId: string

    readonly importPotentialApplicantListMembersBody: ImportPotentialApplicantListMembersBody
}

/**
 * Request parameters for userApiIsUsernameAvailable operation in UserApiApi.
 */
export interface UserApiApiUserApiIsUsernameAvailableRequest {
    readonly username: string
}

/**
 * Request parameters for userApiJobRoleAutoComplete operation in UserApiApi.
 */
export interface UserApiApiUserApiJobRoleAutoCompleteRequest {
    readonly orderBy?: string

    readonly pageNo?: string

    readonly pageSize?: string

    readonly query?: string
}

/**
 * Request parameters for userApiLastAppliedPotentialApplicantJobRoles operation in UserApiApi.
 */
export interface UserApiApiUserApiLastAppliedPotentialApplicantJobRolesRequest {
    readonly searchQuery?: string
}

/**
 * Request parameters for userApiOnboardingDone operation in UserApiApi.
 */
export interface UserApiApiUserApiOnboardingDoneRequest {
    readonly onboardingDoneBody: OnboardingDoneBody
}

/**
 * Request parameters for userApiPhoneActivation operation in UserApiApi.
 */
export interface UserApiApiUserApiPhoneActivationRequest {
    readonly sendPhoneOtpBodyBase: SendPhoneOtpBodyBase
}

/**
 * Request parameters for userApiPostAdminCustomReferralList operation in UserApiApi.
 */
export interface UserApiApiUserApiPostAdminCustomReferralListRequest {
    readonly adminCustomReferralListBase: AdminCustomReferralListBase
}

/**
 * Request parameters for userApiProject operation in UserApiApi.
 */
export interface UserApiApiUserApiProjectRequest {
    readonly jobProfileProject: JobProfileProject
}

/**
 * Request parameters for userApiRecordPendingAppReferral operation in UserApiApi.
 */
export interface UserApiApiUserApiRecordPendingAppReferralRequest {
    readonly recordPendingAppReferralBody: RecordPendingAppReferralBody
}

/**
 * Request parameters for userApiReferByEmails operation in UserApiApi.
 */
export interface UserApiApiUserApiReferByEmailsRequest {
    readonly referByEmailBody: ReferByEmailBody
}

/**
 * Request parameters for userApiRemoveFollowedUsers operation in UserApiApi.
 */
export interface UserApiApiUserApiRemoveFollowedUsersRequest {
    readonly followedUserId: string
}

/**
 * Request parameters for userApiResetUserCompletely operation in UserApiApi.
 */
export interface UserApiApiUserApiResetUserCompletelyRequest {
    readonly userId: string
}

/**
 * Request parameters for userApiResetUserPassword operation in UserApiApi.
 */
export interface UserApiApiUserApiResetUserPasswordRequest {
    readonly resetPasswordBody: ResetPasswordBody
}

/**
 * Request parameters for userApiResumeShare operation in UserApiApi.
 */
export interface UserApiApiUserApiResumeShareRequest {
    readonly bulkResumeShareBody: BulkResumeShareBody
}

/**
 * Request parameters for userApiResumeView operation in UserApiApi.
 */
export interface UserApiApiUserApiResumeViewRequest {
    readonly resumeId: string
}

/**
 * Request parameters for userApiRewardBonusToUser operation in UserApiApi.
 */
export interface UserApiApiUserApiRewardBonusToUserRequest {
    readonly rewardBonusBody: RewardBonusBody
}

/**
 * Request parameters for userApiSendPasswordResetOtp operation in UserApiApi.
 */
export interface UserApiApiUserApiSendPasswordResetOtpRequest {
    readonly sendEmailOtpBody: SendEmailOtpBody
}

/**
 * Request parameters for userApiSetCertificateVisibility operation in UserApiApi.
 */
export interface UserApiApiUserApiSetCertificateVisibilityRequest {
    readonly certificateId: string

    readonly certificateVisibilityBody: CertificateVisibilityBody
}

/**
 * Request parameters for userApiSetDashboardPersona operation in UserApiApi.
 */
export interface UserApiApiUserApiSetDashboardPersonaRequest {
    readonly dashboardPersonaBody: DashboardPersonaBody
}

/**
 * Request parameters for userApiSetNewPassword operation in UserApiApi.
 */
export interface UserApiApiUserApiSetNewPasswordRequest {
    readonly setNewPasswordBody: SetNewPasswordBody
}

/**
 * Request parameters for userApiSetUserReferralMultiplier operation in UserApiApi.
 */
export interface UserApiApiUserApiSetUserReferralMultiplierRequest {
    readonly userId: string

    readonly updateReferralMultiplierBody: UpdateReferralMultiplierBody
}

/**
 * Request parameters for userApiSkipProfileCompletionItem operation in UserApiApi.
 */
export interface UserApiApiUserApiSkipProfileCompletionItemRequest {
    readonly skipProfileItemBody: SkipProfileItemBody
}

/**
 * Request parameters for userApiToggleResumeLike operation in UserApiApi.
 */
export interface UserApiApiUserApiToggleResumeLikeRequest {
    readonly resumeId: string
}

/**
 * Request parameters for userApiUpdateAdminCustomReferralList operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdateAdminCustomReferralListRequest {
    readonly customReferralsId: string

    readonly adminCustomReferralListBase: AdminCustomReferralListBase
}

/**
 * Request parameters for userApiUpdateAward operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdateAwardRequest {
    readonly awardId: string

    readonly jobProfileAwardBase: JobProfileAwardBase
}

/**
 * Request parameters for userApiUpdateCertification operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdateCertificationRequest {
    readonly certId: string

    readonly jobProfileCertificationBase: JobProfileCertificationBase
}

/**
 * Request parameters for userApiUpdateCollege operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdateCollegeRequest {
    readonly collegeId: string

    readonly address?: string | null

    readonly approvalStatus?: string

    readonly collegeAdminId?: string | null

    readonly collegeName?: string

    readonly collegeType?: string | null

    readonly defaultColor?: string | null

    readonly description?: string | null

    readonly directorName?: string | null

    readonly districtName?: string | null

    readonly email?: string | null

    readonly imageUrl?: string | null

    readonly isEmailVerified?: boolean

    readonly isPhoneVerified?: boolean

    readonly jointDirectorName?: string | null

    readonly password?: string | null

    readonly phoneNumber?: string | null

    readonly stateName?: string | null

    readonly universityName?: string | null
}

/**
 * Request parameters for userApiUpdateCompany operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdateCompanyRequest {
    readonly companyId: string

    readonly approvalStatus?: string | null

    readonly companyDescription?: string | null

    readonly companyName?: string | null

    readonly companySize?: string | null

    readonly corporateIdentificationNumber?: string | null

    readonly defaultColor?: string | null

    readonly imageUrl?: string | null
}

/**
 * Request parameters for userApiUpdateInterest operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdateInterestRequest {
    readonly interestId: string

    readonly jobProfileInterestBase: JobProfileInterestBase
}

/**
 * Request parameters for userApiUpdateJobRole operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdateJobRoleRequest {
    readonly updateJobRoleBody: Array<UpdateJobRoleBody>
}

/**
 * Request parameters for userApiUpdateLanguage operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdateLanguageRequest {
    readonly languageId: string

    readonly jobProfileLanguageBase: JobProfileLanguageBase
}

/**
 * Request parameters for userApiUpdatePositionOfResponsibility operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdatePositionOfResponsibilityRequest {
    readonly positionId: string

    readonly jobProfilePositionOfResponsibilityBase: JobProfilePositionOfResponsibilityBase
}

/**
 * Request parameters for userApiUpdatePublication operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdatePublicationRequest {
    readonly publicationId: string

    readonly jobProfilePublicationBase: JobProfilePublicationBase
}

/**
 * Request parameters for userApiUpdateReferralBaseMultiplier operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdateReferralBaseMultiplierRequest {
    readonly updateReferralMultiplierBody: UpdateReferralMultiplierBody
}

/**
 * Request parameters for userApiUpdateReferralMilestone operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdateReferralMilestoneRequest {
    readonly milestoneId: string

    readonly updateReferralMilestoneBody: UpdateReferralMilestoneBody
}

/**
 * Request parameters for userApiUpdateResumeAccess operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdateResumeAccessRequest {
    readonly resumeAccessId: string

    readonly resumeShareBody: ResumeShareBody
}

/**
 * Request parameters for userApiUpdateUserEmail operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdateUserEmailRequest {
    readonly updateUserEmailBody: UpdateUserEmailBody
}

/**
 * Request parameters for userApiUpdateUserProfile operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdateUserProfileRequest {
    readonly updateUserBody: UpdateUserBody
}

/**
 * Request parameters for userApiUpdateUserResumeVisibility operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdateUserResumeVisibilityRequest {
    readonly resumeId: string

    readonly isDefault?: boolean

    readonly title?: string

    readonly visibility?: string
}

/**
 * Request parameters for userApiUpdateViewedTour operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdateViewedTourRequest {
    readonly onboardingDoneBody: OnboardingDoneBody
}

/**
 * Request parameters for userApiUpdateVolunteerExperience operation in UserApiApi.
 */
export interface UserApiApiUserApiUpdateVolunteerExperienceRequest {
    readonly volunteerId: string

    readonly jobProfileVolunteerExperienceBase: JobProfileVolunteerExperienceBase
}

/**
 * Request parameters for userApiUploadMiscImage operation in UserApiApi.
 */
export interface UserApiApiUserApiUploadMiscImageRequest {
    readonly imageFile: File
}

/**
 * Request parameters for userApiUploadUserProfilePicture operation in UserApiApi.
 */
export interface UserApiApiUserApiUploadUserProfilePictureRequest {
    readonly picture: File
}

/**
 * Request parameters for userApiUpsertSocialLinks operation in UserApiApi.
 */
export interface UserApiApiUserApiUpsertSocialLinksRequest {
    readonly socialLinksBody: Array<SocialLinksBody>
}

/**
 * Request parameters for userApiVerifyEmailOtp operation in UserApiApi.
 */
export interface UserApiApiUserApiVerifyEmailOtpRequest {
    readonly verifyEmailOtpBody: VerifyEmailOtpBody
}

/**
 * Request parameters for userApiVerifyPhoneOtp operation in UserApiApi.
 */
export interface UserApiApiUserApiVerifyPhoneOtpRequest {
    readonly verifyPhoneOtpBody: VerifyPhoneOtpBody
}

/**
 * Request parameters for userApiWorkDetails operation in UserApiApi.
 */
export interface UserApiApiUserApiWorkDetailsRequest {
    readonly workExperience: WorkExperience
}

/**
 * UserApiApi - object-oriented interface
 */
export class UserApiApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiActivateFreeAbekusPremium(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiActivateFreeAbekusPremium(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiAddAwardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiAddAward(requestParameters: UserApiApiUserApiAddAwardRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiAddAward(requestParameters.jobProfileAwardBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiAddCertificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiAddCertification(requestParameters: UserApiApiUserApiAddCertificationRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiAddCertification(requestParameters.jobProfileCertificationBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiAddFollowedUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiAddFollowedUsers(requestParameters: UserApiApiUserApiAddFollowedUsersRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiAddFollowedUsers(requestParameters.followedUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiAddInterestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiAddInterest(requestParameters: UserApiApiUserApiAddInterestRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiAddInterest(requestParameters.jobProfileInterestBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiAddLanguageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiAddLanguage(requestParameters: UserApiApiUserApiAddLanguageRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiAddLanguage(requestParameters.jobProfileLanguageBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiAddPositionOfResponsibilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiAddPositionOfResponsibility(requestParameters: UserApiApiUserApiAddPositionOfResponsibilityRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiAddPositionOfResponsibility(requestParameters.jobProfilePositionOfResponsibilityBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiAddPublicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiAddPublication(requestParameters: UserApiApiUserApiAddPublicationRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiAddPublication(requestParameters.jobProfilePublicationBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiAddVolunteerExperienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiAddVolunteerExperience(requestParameters: UserApiApiUserApiAddVolunteerExperienceRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiAddVolunteerExperience(requestParameters.jobProfileVolunteerExperienceBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiAdminUserUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiAdminUserUpdate(requestParameters: UserApiApiUserApiAdminUserUpdateRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiAdminUserUpdate(requestParameters.userId, requestParameters.adminUserUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiAppleAuthMobileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiAppleAuthMobile(requestParameters: UserApiApiUserApiAppleAuthMobileRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiAppleAuthMobile(requestParameters.appleAuthMobileBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiAutofillProfileFromResumeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiAutofillProfileFromResume(requestParameters: UserApiApiUserApiAutofillProfileFromResumeRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiAutofillProfileFromResume(requestParameters.resumeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiBulkPopulateUserResumesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiBulkPopulateUserResumes(requestParameters: UserApiApiUserApiBulkPopulateUserResumesRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiBulkPopulateUserResumes(requestParameters.iDListNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiChangeEducationDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiChangeEducationDetails(requestParameters: UserApiApiUserApiChangeEducationDetailsRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiChangeEducationDetails(requestParameters.educationId, requestParameters.educationDetails, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiChangeProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiChangeProject(requestParameters: UserApiApiUserApiChangeProjectRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiChangeProject(requestParameters.projectId, requestParameters.jobProfileProject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiChangeUserPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiChangeUserPassword(requestParameters: UserApiApiUserApiChangeUserPasswordRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiChangeUserPassword(requestParameters.changePasswordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiChangeUserTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiChangeUserType(requestParameters: UserApiApiUserApiChangeUserTypeRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiChangeUserType(requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiChangeWorkDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiChangeWorkDetails(requestParameters: UserApiApiUserApiChangeWorkDetailsRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiChangeWorkDetails(requestParameters.workId, requestParameters.workExperience, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiClearUserReferralMultiplierRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiClearUserReferralMultiplier(requestParameters: UserApiApiUserApiClearUserReferralMultiplierRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiClearUserReferralMultiplier(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiCollegeAutocompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiCollegeAutocomplete(requestParameters: UserApiApiUserApiCollegeAutocompleteRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiCollegeAutocomplete(requestParameters.page, requestParameters.pageSize, requestParameters.query, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiCollegeDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiCollegeDetails(requestParameters: UserApiApiUserApiCollegeDetailsRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiCollegeDetails(requestParameters.createCollegeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiCompanyAutocompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiCompanyAutocomplete(requestParameters: UserApiApiUserApiCompanyAutocompleteRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiCompanyAutocomplete(requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiCompanyCollegeDefaultColor(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiCompanyCollegeDefaultColor(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiCompanyDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiCompanyDetails(requestParameters: UserApiApiUserApiCompanyDetailsRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiCompanyDetails(requestParameters.createCompanyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiCreateBulkPotentialRecruitersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiCreateBulkPotentialRecruiters(requestParameters: UserApiApiUserApiCreateBulkPotentialRecruitersRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiCreateBulkPotentialRecruiters(requestParameters.createPotentialRecruiterBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiCreateJobRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiCreateJobRole(requestParameters: UserApiApiUserApiCreateJobRoleRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiCreateJobRole(requestParameters.createJobRoleBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiCreateMissingUsernames(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiCreateMissingUsernames(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiCreatePotentialApplicantListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiCreatePotentialApplicantList(requestParameters: UserApiApiUserApiCreatePotentialApplicantListRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiCreatePotentialApplicantList(requestParameters.createPotentialApplicantListBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiCreatePotentialApplicantsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiCreatePotentialApplicants(requestParameters: UserApiApiUserApiCreatePotentialApplicantsRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiCreatePotentialApplicants(requestParameters.createPotentialApplicantsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiCreateReferralMilestoneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiCreateReferralMilestone(requestParameters: UserApiApiUserApiCreateReferralMilestoneRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiCreateReferralMilestone(requestParameters.createReferralMilestoneBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiCreateUser(requestParameters: UserApiApiUserApiCreateUserRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiCreateUser(requestParameters.createUserBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteAdminCustomReferralListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteAdminCustomReferralList(requestParameters: UserApiApiUserApiDeleteAdminCustomReferralListRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteAdminCustomReferralList(requestParameters.customReferralsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteAwardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteAward(requestParameters: UserApiApiUserApiDeleteAwardRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteAward(requestParameters.awardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteCertificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteCertification(requestParameters: UserApiApiUserApiDeleteCertificationRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteCertification(requestParameters.certId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteCollegeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteCollege(requestParameters: UserApiApiUserApiDeleteCollegeRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteCollege(requestParameters.iDList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteCompany(requestParameters: UserApiApiUserApiDeleteCompanyRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteCompany(requestParameters.iDList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteEducationDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteEducationDetails(requestParameters: UserApiApiUserApiDeleteEducationDetailsRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteEducationDetails(requestParameters.educationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteInactiveUsers(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteInactiveUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteInterestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteInterest(requestParameters: UserApiApiUserApiDeleteInterestRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteInterest(requestParameters.interestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteJobRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteJobRole(requestParameters: UserApiApiUserApiDeleteJobRoleRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteJobRole(requestParameters.iDList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteLanguageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteLanguage(requestParameters: UserApiApiUserApiDeleteLanguageRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteLanguage(requestParameters.languageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteMyUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteMyUser(requestParameters: UserApiApiUserApiDeleteMyUserRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteMyUser(requestParameters.deleteUserBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeletePositionOfResponsibilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeletePositionOfResponsibility(requestParameters: UserApiApiUserApiDeletePositionOfResponsibilityRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeletePositionOfResponsibility(requestParameters.positionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeletePotentialApplicantListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeletePotentialApplicantList(requestParameters: UserApiApiUserApiDeletePotentialApplicantListRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeletePotentialApplicantList(requestParameters.listId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteProject(requestParameters: UserApiApiUserApiDeleteProjectRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteProject(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeletePublicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeletePublication(requestParameters: UserApiApiUserApiDeletePublicationRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeletePublication(requestParameters.publicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteReferralMilestoneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteReferralMilestone(requestParameters: UserApiApiUserApiDeleteReferralMilestoneRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteReferralMilestone(requestParameters.milestoneId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteResumeAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteResumeAccess(requestParameters: UserApiApiUserApiDeleteResumeAccessRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteResumeAccess(requestParameters.resumeAccessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteSocialLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteSocialLink(requestParameters: UserApiApiUserApiDeleteSocialLinkRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteSocialLink(requestParameters.socialLinkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteTempUserCompletely(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteTempUserCompletely(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteUserCompletelyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteUserCompletely(requestParameters: UserApiApiUserApiDeleteUserCompletelyRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteUserCompletely(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteUserResumeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteUserResume(requestParameters: UserApiApiUserApiDeleteUserResumeRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteUserResume(requestParameters.resumeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteVolunteerExperienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteVolunteerExperience(requestParameters: UserApiApiUserApiDeleteVolunteerExperienceRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteVolunteerExperience(requestParameters.volunteerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiDeleteWorkDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiDeleteWorkDetails(requestParameters: UserApiApiUserApiDeleteWorkDetailsRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiDeleteWorkDetails(requestParameters.workId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiEducationDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiEducationDetails(requestParameters: UserApiApiUserApiEducationDetailsRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiEducationDetails(requestParameters.educationDetails, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiEmailActivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiEmailActivation(requestParameters: UserApiApiUserApiEmailActivationRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiEmailActivation(requestParameters.sendEmailOtpBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiFetchResumeJsonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiFetchResumeJson(requestParameters: UserApiApiUserApiFetchResumeJsonRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiFetchResumeJson(requestParameters.resumeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiFetchUserResumesJson(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiFetchUserResumesJson(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGauthMobileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGauthMobile(requestParameters: UserApiApiUserApiGauthMobileRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGauthMobile(requestParameters.gAuthMobileBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGenerateResumeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGenerateResume(requestParameters: UserApiApiUserApiGenerateResumeRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGenerateResume(requestParameters.jsonResumeGenerate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetAdminCustomReferralListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetAdminCustomReferralList(requestParameters: UserApiApiUserApiGetAdminCustomReferralListRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetAdminCustomReferralList(requestParameters.page, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetAdminReferralMilestones(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetAdminReferralMilestones(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetAdminReferralMultiplier(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetAdminReferralMultiplier(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetApplicantStatusInfo(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetApplicantStatusInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetCollegeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetCollege(requestParameters: UserApiApiUserApiGetCollegeRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetCollege(requestParameters.collegeId, requestParameters.collegeName, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.status, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetCompany(requestParameters: UserApiApiUserApiGetCompanyRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetCompany(requestParameters.companyId, requestParameters.companyName, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.status, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetEarnCreditsGoals(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetEarnCreditsGoals(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetFeaturedCompanies(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetFeaturedCompanies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetFollowedUsers(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetFollowedUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetGemsActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetGemsActivity(requestParameters: UserApiApiUserApiGetGemsActivityRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetGemsActivity(requestParameters.gemsActivityParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetJobRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetJobRole(requestParameters: UserApiApiUserApiGetJobRoleRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetJobRole(requestParameters.jobRoleId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.showJobAssociatedRoles, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.status, requestParameters.userSearchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetLeaderboardByUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetLeaderboardByUser(requestParameters: UserApiApiUserApiGetLeaderboardByUserRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetLeaderboardByUser(requestParameters.competitionId, requestParameters.onlyFollowed, requestParameters.page, requestParameters.pageSize, requestParameters.showUserRank, requestParameters.skillId, requestParameters.timePeriod, requestParameters.userSearchQuery, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetMiniProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetMiniProfile(requestParameters: UserApiApiUserApiGetMiniProfileRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetMiniProfile(requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetMyBadges(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetMyBadges(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetOnlineUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetOnlineUsers(requestParameters: UserApiApiUserApiGetOnlineUsersRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetOnlineUsers(requestParameters.excludeInvited, requestParameters.forInvite, requestParameters.page, requestParameters.pageSize, requestParameters.roomId, requestParameters.skillIds, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetPotentialApplicantFacetValuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetPotentialApplicantFacetValues(requestParameters: UserApiApiUserApiGetPotentialApplicantFacetValuesRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetPotentialApplicantFacetValues(requestParameters.field, requestParameters.orderByMaxCount, requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetPotentialApplicantLists(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetPotentialApplicantLists(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetPotentialApplicantsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetPotentialApplicants(requestParameters: UserApiApiUserApiGetPotentialApplicantsRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetPotentialApplicants(requestParameters.getPotentialApplicantsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetPotentialApplicantsCourseSpecializationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetPotentialApplicantsCourseSpecializations(requestParameters: UserApiApiUserApiGetPotentialApplicantsCourseSpecializationsRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetPotentialApplicantsCourseSpecializations(requestParameters.orderByMaxCount, requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetPotentialApplicantsJobRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetPotentialApplicantsJobRoles(requestParameters: UserApiApiUserApiGetPotentialApplicantsJobRolesRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetPotentialApplicantsJobRoles(requestParameters.orderByMaxCount, requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetPotentialRecruiterGoogleAdsMetadataCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetPotentialRecruiterGoogleAdsMetadataCsv(requestParameters: UserApiApiUserApiGetPotentialRecruiterGoogleAdsMetadataCsvRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetPotentialRecruiterGoogleAdsMetadataCsv(requestParameters.getPotentialRecruiterCsvParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetPotentialRecruitersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetPotentialRecruiters(requestParameters: UserApiApiUserApiGetPotentialRecruitersRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetPotentialRecruiters(requestParameters.potentialRecruiterParameter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetPotentialRecruitersJobPostedCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetPotentialRecruitersJobPostedCategories(requestParameters: UserApiApiUserApiGetPotentialRecruitersJobPostedCategoriesRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetPotentialRecruitersJobPostedCategories(requestParameters.orderByMaxCount, requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetProfileCompletion(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetProfileCompletion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetPublicCommunityUpdatesActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetPublicCommunityUpdatesActivity(requestParameters: UserApiApiUserApiGetPublicCommunityUpdatesActivityRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetPublicCommunityUpdatesActivity(requestParameters.page, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetQuestionAuthorList(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetQuestionAuthorList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetReferralActivityLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetReferralActivityLogs(requestParameters: UserApiApiUserApiGetReferralActivityLogsRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetReferralActivityLogs(requestParameters.userId, requestParameters.endDate, requestParameters.page, requestParameters.pageSize, requestParameters.startDate, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetReferralEmailPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetReferralEmailPreview(requestParameters: UserApiApiUserApiGetReferralEmailPreviewRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetReferralEmailPreview(requestParameters.hideReferredBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetReferralSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetReferralSummary(requestParameters: UserApiApiUserApiGetReferralSummaryRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetReferralSummary(requestParameters.createdFrom, requestParameters.createdTo, requestParameters.lastReferredFrom, requestParameters.lastReferredTo, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetResumeAccessListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetResumeAccessList(requestParameters: UserApiApiUserApiGetResumeAccessListRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetResumeAccessList(requestParameters.resumeId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetResumeActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetResumeActivity(requestParameters: UserApiApiUserApiGetResumeActivityRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetResumeActivity(requestParameters.resumeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetUserActivityCalendarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetUserActivityCalendar(requestParameters: UserApiApiUserApiGetUserActivityCalendarRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetUserActivityCalendar(requestParameters.endDate, requestParameters.startDate, requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetUserAnalyticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetUserAnalytics(requestParameters: UserApiApiUserApiGetUserAnalyticsRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetUserAnalytics(requestParameters.domainId, requestParameters.onlyAttempted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetUserCertificatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetUserCertificates(requestParameters: UserApiApiUserApiGetUserCertificatesRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetUserCertificates(requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetUserCommunityUpdatesActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetUserCommunityUpdatesActivity(requestParameters: UserApiApiUserApiGetUserCommunityUpdatesActivityRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetUserCommunityUpdatesActivity(requestParameters.page, requestParameters.pageSize, requestParameters.skillId, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetUserCreatedQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetUserCreatedQuestions(requestParameters: UserApiApiUserApiGetUserCreatedQuestionsRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetUserCreatedQuestions(requestParameters.page, requestParameters.pageSize, requestParameters.questionStatus, requestParameters.searchQuery, requestParameters.skillIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetUserDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetUserDetails(requestParameters: UserApiApiUserApiGetUserDetailsRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetUserDetails(requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetUserFullJsonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetUserFullJson(requestParameters: UserApiApiUserApiGetUserFullJsonRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetUserFullJson(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetUserList(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetUserList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetUserLoginStreakDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetUserLoginStreakDetails(requestParameters: UserApiApiUserApiGetUserLoginStreakDetailsRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetUserLoginStreakDetails(requestParameters.endDate, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetUserMonthlyScoreRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetUserMonthlyScore(requestParameters: UserApiApiUserApiGetUserMonthlyScoreRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetUserMonthlyScore(requestParameters.username, requestParameters.endMonth, requestParameters.months, requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetUserPublicProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetUserPublicProfile(requestParameters: UserApiApiUserApiGetUserPublicProfileRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetUserPublicProfile(requestParameters.username, requestParameters.onlyAnalytics, requestParameters.onlyAttempted, requestParameters.pageNo, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetUserReferralsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetUserReferrals(requestParameters: UserApiApiUserApiGetUserReferralsRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetUserReferrals(requestParameters.page, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiGetUserResumesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetUserResumes(requestParameters: UserApiApiUserApiGetUserResumesRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetUserResumes(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetUserSelf(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetUserSelf(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetUserSelfResume(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetUserSelfResume(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiGetUsersJobReferralData(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiGetUsersJobReferralData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiImportPotentialApplicantListMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiImportPotentialApplicantListMembers(requestParameters: UserApiApiUserApiImportPotentialApplicantListMembersRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiImportPotentialApplicantListMembers(requestParameters.listId, requestParameters.importPotentialApplicantListMembersBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiIsUsernameAvailableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiIsUsernameAvailable(requestParameters: UserApiApiUserApiIsUsernameAvailableRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiIsUsernameAvailable(requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiJobRoleAutoCompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiJobRoleAutoComplete(requestParameters: UserApiApiUserApiJobRoleAutoCompleteRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiJobRoleAutoComplete(requestParameters.orderBy, requestParameters.pageNo, requestParameters.pageSize, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiLastAppliedPotentialApplicantJobRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiLastAppliedPotentialApplicantJobRoles(requestParameters: UserApiApiUserApiLastAppliedPotentialApplicantJobRolesRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiLastAppliedPotentialApplicantJobRoles(requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiMarkAutoApplyDialogShown(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiMarkAutoApplyDialogShown(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiMarkVoucherPopupDismissed(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiMarkVoucherPopupDismissed(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiOnboardingDoneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiOnboardingDone(requestParameters: UserApiApiUserApiOnboardingDoneRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiOnboardingDone(requestParameters.onboardingDoneBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiPhoneActivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiPhoneActivation(requestParameters: UserApiApiUserApiPhoneActivationRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiPhoneActivation(requestParameters.sendPhoneOtpBodyBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiPostAdminCustomReferralListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiPostAdminCustomReferralList(requestParameters: UserApiApiUserApiPostAdminCustomReferralListRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiPostAdminCustomReferralList(requestParameters.adminCustomReferralListBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiProject(requestParameters: UserApiApiUserApiProjectRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiProject(requestParameters.jobProfileProject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiRecordPendingAppReferralRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiRecordPendingAppReferral(requestParameters: UserApiApiUserApiRecordPendingAppReferralRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiRecordPendingAppReferral(requestParameters.recordPendingAppReferralBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiRecruiterDataNormalisation(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiRecruiterDataNormalisation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiReferByEmailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiReferByEmails(requestParameters: UserApiApiUserApiReferByEmailsRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiReferByEmails(requestParameters.referByEmailBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiRemoveFollowedUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiRemoveFollowedUsers(requestParameters: UserApiApiUserApiRemoveFollowedUsersRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiRemoveFollowedUsers(requestParameters.followedUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiResetUserCompletelyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiResetUserCompletely(requestParameters: UserApiApiUserApiResetUserCompletelyRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiResetUserCompletely(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiResetUserPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiResetUserPassword(requestParameters: UserApiApiUserApiResetUserPasswordRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiResetUserPassword(requestParameters.resetPasswordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiResumeDetails(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiResumeDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiResumeShareRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiResumeShare(requestParameters: UserApiApiUserApiResumeShareRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiResumeShare(requestParameters.bulkResumeShareBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiResumeViewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiResumeView(requestParameters: UserApiApiUserApiResumeViewRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiResumeView(requestParameters.resumeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiRewardBonusToUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiRewardBonusToUser(requestParameters: UserApiApiUserApiRewardBonusToUserRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiRewardBonusToUser(requestParameters.rewardBonusBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiSelectDomain(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiSelectDomain(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiSendPasswordResetOtpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiSendPasswordResetOtp(requestParameters: UserApiApiUserApiSendPasswordResetOtpRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiSendPasswordResetOtp(requestParameters.sendEmailOtpBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiSetCertificateVisibilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiSetCertificateVisibility(requestParameters: UserApiApiUserApiSetCertificateVisibilityRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiSetCertificateVisibility(requestParameters.certificateId, requestParameters.certificateVisibilityBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiSetDashboardPersonaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiSetDashboardPersona(requestParameters: UserApiApiUserApiSetDashboardPersonaRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiSetDashboardPersona(requestParameters.dashboardPersonaBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiSetNewPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiSetNewPassword(requestParameters: UserApiApiUserApiSetNewPasswordRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiSetNewPassword(requestParameters.setNewPasswordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiSetUserReferralMultiplierRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiSetUserReferralMultiplier(requestParameters: UserApiApiUserApiSetUserReferralMultiplierRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiSetUserReferralMultiplier(requestParameters.userId, requestParameters.updateReferralMultiplierBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiSkipProfileCompletionItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiSkipProfileCompletionItem(requestParameters: UserApiApiUserApiSkipProfileCompletionItemRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiSkipProfileCompletionItem(requestParameters.skipProfileItemBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiToggleResumeLikeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiToggleResumeLike(requestParameters: UserApiApiUserApiToggleResumeLikeRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiToggleResumeLike(requestParameters.resumeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdateAdminCustomReferralListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateAdminCustomReferralList(requestParameters: UserApiApiUserApiUpdateAdminCustomReferralListRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateAdminCustomReferralList(requestParameters.customReferralsId, requestParameters.adminCustomReferralListBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateAutoPractiseMetadata(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateAutoPractiseMetadata(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdateAwardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateAward(requestParameters: UserApiApiUserApiUpdateAwardRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateAward(requestParameters.awardId, requestParameters.jobProfileAwardBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdateCertificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateCertification(requestParameters: UserApiApiUserApiUpdateCertificationRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateCertification(requestParameters.certId, requestParameters.jobProfileCertificationBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdateCollegeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateCollege(requestParameters: UserApiApiUserApiUpdateCollegeRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateCollege(requestParameters.collegeId, requestParameters.address, requestParameters.approvalStatus, requestParameters.collegeAdminId, requestParameters.collegeName, requestParameters.collegeType, requestParameters.defaultColor, requestParameters.description, requestParameters.directorName, requestParameters.districtName, requestParameters.email, requestParameters.imageUrl, requestParameters.isEmailVerified, requestParameters.isPhoneVerified, requestParameters.jointDirectorName, requestParameters.password, requestParameters.phoneNumber, requestParameters.stateName, requestParameters.universityName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdateCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateCompany(requestParameters: UserApiApiUserApiUpdateCompanyRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateCompany(requestParameters.companyId, requestParameters.approvalStatus, requestParameters.companyDescription, requestParameters.companyName, requestParameters.companySize, requestParameters.corporateIdentificationNumber, requestParameters.defaultColor, requestParameters.imageUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdateInterestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateInterest(requestParameters: UserApiApiUserApiUpdateInterestRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateInterest(requestParameters.interestId, requestParameters.jobProfileInterestBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateJobApplicantsUserResumes(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateJobApplicantsUserResumes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdateJobRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateJobRole(requestParameters: UserApiApiUserApiUpdateJobRoleRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateJobRole(requestParameters.updateJobRoleBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdateLanguageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateLanguage(requestParameters: UserApiApiUserApiUpdateLanguageRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateLanguage(requestParameters.languageId, requestParameters.jobProfileLanguageBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdatePositionOfResponsibilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdatePositionOfResponsibility(requestParameters: UserApiApiUserApiUpdatePositionOfResponsibilityRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdatePositionOfResponsibility(requestParameters.positionId, requestParameters.jobProfilePositionOfResponsibilityBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdatePractiseMetadata(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdatePractiseMetadata(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdatePublicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdatePublication(requestParameters: UserApiApiUserApiUpdatePublicationRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdatePublication(requestParameters.publicationId, requestParameters.jobProfilePublicationBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdateReferralBaseMultiplierRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateReferralBaseMultiplier(requestParameters: UserApiApiUserApiUpdateReferralBaseMultiplierRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateReferralBaseMultiplier(requestParameters.updateReferralMultiplierBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdateReferralMilestoneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateReferralMilestone(requestParameters: UserApiApiUserApiUpdateReferralMilestoneRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateReferralMilestone(requestParameters.milestoneId, requestParameters.updateReferralMilestoneBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdateResumeAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateResumeAccess(requestParameters: UserApiApiUserApiUpdateResumeAccessRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateResumeAccess(requestParameters.resumeAccessId, requestParameters.resumeShareBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdateUserEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateUserEmail(requestParameters: UserApiApiUserApiUpdateUserEmailRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateUserEmail(requestParameters.updateUserEmailBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdateUserProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateUserProfile(requestParameters: UserApiApiUserApiUpdateUserProfileRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateUserProfile(requestParameters.updateUserBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdateUserResumeVisibilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateUserResumeVisibility(requestParameters: UserApiApiUserApiUpdateUserResumeVisibilityRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateUserResumeVisibility(requestParameters.resumeId, requestParameters.isDefault, requestParameters.title, requestParameters.visibility, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdateViewedTourRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateViewedTour(requestParameters: UserApiApiUserApiUpdateViewedTourRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateViewedTour(requestParameters.onboardingDoneBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpdateVolunteerExperienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpdateVolunteerExperience(requestParameters: UserApiApiUserApiUpdateVolunteerExperienceRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpdateVolunteerExperience(requestParameters.volunteerId, requestParameters.jobProfileVolunteerExperienceBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUploadExcelFile(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUploadExcelFile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUploadMiscImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUploadMiscImage(requestParameters: UserApiApiUserApiUploadMiscImageRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUploadMiscImage(requestParameters.imageFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUploadUserProfilePictureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUploadUserProfilePicture(requestParameters: UserApiApiUserApiUploadUserProfilePictureRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUploadUserProfilePicture(requestParameters.picture, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiUpsertSocialLinksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUpsertSocialLinks(requestParameters: UserApiApiUserApiUpsertSocialLinksRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUpsertSocialLinks(requestParameters.socialLinksBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiUserRequestedAccountDeletion(options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiUserRequestedAccountDeletion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiVerifyEmailOtpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiVerifyEmailOtp(requestParameters: UserApiApiUserApiVerifyEmailOtpRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiVerifyEmailOtp(requestParameters.verifyEmailOtpBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiVerifyPhoneOtpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiVerifyPhoneOtp(requestParameters: UserApiApiUserApiVerifyPhoneOtpRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiVerifyPhoneOtp(requestParameters.verifyPhoneOtpBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiApiUserApiWorkDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userApiWorkDetails(requestParameters: UserApiApiUserApiWorkDetailsRequest, options?: RawAxiosRequestConfig) {
        return UserApiApiFp(this.configuration).userApiWorkDetails(requestParameters.workExperience, options).then((request) => request(this.axios, this.basePath));
    }
}

